(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15765,42227,68425,48308],{

/***/ 81424:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgotpassword",
      function () {
        return __webpack_require__(94490);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ forgotpassword; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/features/edit-profile/styled.ts
var styled = __webpack_require__(686);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/global/CustomInput/styled.ts
var CustomInput_styled = __webpack_require__(71487);
;// CONCATENATED MODULE: ./src/features/change-forgot-password/SectionEmailField.tsx
/* eslint-disable react/destructuring-assignment */ 





var SectionPasswordField = function(param) {
    var onSubmit = param.onSubmit, preventSubmit = param.preventSubmit, submitText = param.submitText, inputPlaceHolder = param.inputPlaceHolder, title = param.title, subTitle = param.subTitle, email = param.email, setEmail = param.setEmail;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        height: "455px",
        direction: "column",
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    width: "100%",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/password-email.svg",
                        width: "70px",
                        height: "70px",
                        alt: "lock",
                        style: {
                            marginBottom: "18px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            paddingBottom: "18px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                weight: 700,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "#858585",
                                pt: "10px",
                                children: subTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput_styled/* Input */.I, {
                        type: "text",
                        autoFocus: true,
                        placeholder: inputPlaceHolder,
                        value: email,
                        onChange: function(e) {
                            return setEmail(e.currentTarget.value);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                block: true,
                type: "primary",
                height: "44px",
                radius: "4px",
                onClick: onSubmit,
                disabled: preventSubmit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: submitText
                })
            })
        ]
    });
};
/* harmony default export */ var SectionEmailField = (SectionPasswordField);

// EXTERNAL MODULE: ./src/features/change-forgot-password/SectionPasswordField.tsx + 2 modules
var change_forgot_password_SectionPasswordField = __webpack_require__(32212);
// EXTERNAL MODULE: ./src/features/change-forgot-password/SectionOTPField.tsx + 3 modules
var SectionOTPField = __webpack_require__(79707);
// EXTERNAL MODULE: ./src/features/change-forgot-password/ModalNavigateConfirmation.tsx
var ModalNavigateConfirmation = __webpack_require__(84116);
// EXTERNAL MODULE: ./src/features/change-forgot-password/ModalSuccess.tsx
var ModalSuccess = __webpack_require__(4365);
// EXTERNAL MODULE: ./src/lib/api/change-forgot-password.ts
var change_forgot_password = __webpack_require__(81766);
// EXTERNAL MODULE: ./src/features/change-forgot-password/config.ts
var config = __webpack_require__(636);
// EXTERNAL MODULE: ./src/features/change-forgot-password/utils.ts
var utils = __webpack_require__(28292);
;// CONCATENATED MODULE: ./src/features/change-forgot-password/hooks/useForgotPasswordNonLogin.ts






var useForgotPasswordNonLogin = function() {
    var ref = (0,react.useState)(""), token = ref[0], setToken = ref[1];
    var ref1 = (0,react.useState)(""), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(false), isSubmitting = ref2[0], setIsSubmitting = ref2[1];
    var ref3 = (0,react.useState)(""), email = ref3[0], setEmail = ref3[1];
    var ref4 = (0,react.useState)({
        new: "",
        confirm: ""
    }), password = ref4[0], setPassword = ref4[1];
    var ref5 = (0,react.useState)({
        uppercase: false,
        lowercase: false,
        number: false,
        characters: false
    }), passwordValidation = ref5[0], setPasswordValidation = ref5[1];
    var ref6 = (0,react.useState)({
        target: "",
        remainingSecond: 0
    }), otpData = ref6[0], setOtpData = ref6[1];
    var ref7 = (0,react.useState)({
        channel: "",
        otp: ""
    }), otpConfig = ref7[0], setOtpConfig = ref7[1];
    var submitNewPassword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cb) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setIsSubmitting(true);
                        _ctx.next = 4;
                        return (0,change_forgot_password/* requestForgotPasswordNonLoginNew */.W)({
                            password: password.new,
                            token: token
                        });
                    case 4:
                        setError("");
                        cb();
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        setError(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.cause) === null || ref === void 0 ? void 0 : ref.message);
                    case 12:
                        _ctx.prev = 12;
                        setIsSubmitting(false);
                        return _ctx.finish(12);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    12,
                    15
                ]
            ]);
        }));
        return function submitNewPassword(cb) {
            return _ref.apply(this, arguments);
        };
    }();
    var submitConfirmPassword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cb) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setIsSubmitting(true);
                        _ctx.next = 4;
                        return (0,change_forgot_password/* requestForgotPasswordNonLoginConfirm */.uX)({
                            password: password.confirm,
                            token: token
                        });
                    case 4:
                        setError("");
                        cb();
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        setError(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.cause) === null || ref === void 0 ? void 0 : ref.message);
                    case 12:
                        _ctx.prev = 12;
                        setIsSubmitting(false);
                        return _ctx.finish(12);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    12,
                    15
                ]
            ]);
        }));
        return function submitConfirmPassword(cb) {
            return _ref.apply(this, arguments);
        };
    }();
    var requestOTP = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cb) {
            var ref, ref1, ref2, ref3, response, givenTime, currentTime, timeDifference, remainingSecond, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        setIsSubmitting(true);
                        _ctx.next = 5;
                        return (0,change_forgot_password/* requestForgotPasswordNonLoginOTP */.V6)(email);
                    case 5:
                        response = _ctx.sent;
                        givenTime = new Date(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.next_attempt_time);
                        currentTime = new Date();
                        timeDifference = givenTime.getTime() - currentTime.getTime();
                        remainingSecond = Math.floor(timeDifference / 1000);
                        /// ///////////
                        setToken(response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.token);
                        setOtpData({
                            target: (0,utils/* maskEmail */.o)(email),
                            remainingSecond: remainingSecond
                        });
                        setOtpConfig({
                            channel: config/* CHANNEL_OTP.EMAIL */.U.EMAIL,
                            otp: ""
                        });
                        if (cb !== undefined) {
                            cb();
                        }
                        _ctx.next = 22;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        setOtpData({
                            target: otpData.target,
                            remainingSecond: 0
                        });
                        setError(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref4 = _ctx.t0.cause) === null || ref4 === void 0 ? void 0 : ref4.message);
                        // Re-throw error so component can handle
                        throw _ctx.t0;
                    case 22:
                        _ctx.prev = 22;
                        setIsSubmitting(false);
                        return _ctx.finish(22);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    16,
                    22,
                    25
                ]
            ]);
        }));
        return function requestOTP(cb) {
            return _ref.apply(this, arguments);
        };
    }();
    var verifyOTP = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cb) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setIsSubmitting(true);
                        _ctx.next = 4;
                        return (0,change_forgot_password/* requestForgotPasswordNonLoginOTPVerify */.p2)({
                            otp: otpConfig.otp,
                            token: token
                        });
                    case 4:
                        setError("");
                        cb();
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        setError(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.cause) === null || ref === void 0 ? void 0 : ref.message);
                    case 12:
                        _ctx.prev = 12;
                        setIsSubmitting(false);
                        return _ctx.finish(12);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    12,
                    15
                ]
            ]);
        }));
        return function verifyOTP(cb) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref;
        setPasswordValidation({
            uppercase: /[A-Z]/.test(password.new),
            lowercase: /[a-z]/.test(password.new),
            number: /\d/.test(password.new),
            characters: ((ref = password.new) === null || ref === void 0 ? void 0 : ref.length) >= 8
        });
    }, [
        password.new
    ]);
    (0,react.useEffect)(function() {
        setError("");
    }, [
        password
    ]);
    return {
        email: email,
        setEmail: setEmail,
        password: password,
        setPassword: setPassword,
        passwordValidation: passwordValidation,
        setOtpConfig: setOtpConfig,
        otpConfig: otpConfig,
        otpData: otpData,
        submitNewPassword: submitNewPassword,
        submitConfirmPassword: submitConfirmPassword,
        requestOTP: requestOTP,
        verifyOTP: verifyOTP,
        isSubmitting: isSubmitting,
        error: error,
        resetError: function() {
            return setError("");
        }
    };
};

// EXTERNAL MODULE: ./src/features/change-forgot-password/ModalBlockedReqOTP.tsx
var ModalBlockedReqOTP = __webpack_require__(18401);
;// CONCATENATED MODULE: ./src/features/change-forgot-password/ForgotPasswordNonLoginSteps.tsx
/* eslint-disable no-undef */ 





















function ForgotPasswordSteps(param) {
    var _backLink = param.backLink, backLink = _backLink === void 0 ? "/login" : _backLink;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = useForgotPasswordNonLogin(), email = ref1.email, setEmail = ref1.setEmail, password = ref1.password, setPassword = ref1.setPassword, passwordValidation = ref1.passwordValidation, setOtpConfig = ref1.setOtpConfig, otpConfig = ref1.otpConfig, otpData = ref1.otpData, submitNewPassword = ref1.submitNewPassword, submitConfirmPassword = ref1.submitConfirmPassword, requestOTP = ref1.requestOTP, verifyOTP = ref1.verifyOTP, isSubmitting = ref1.isSubmitting, error = ref1.error, resetError = ref1.resetError;
    var ref2 = (0,react.useState)(false), visibleConfirmModal = ref2[0], setVisibleConfirmModal = ref2[1];
    var ref3 = (0,react.useState)(false), successCreatePassword = ref3[0], setSuccessCreatePassword = ref3[1];
    var ref4 = (0,react.useState)(false), showModalBlocked = ref4[0], setShowModalBlocked = ref4[1];
    var ref5 = (0,react.useState)(0), forgotPassStep = ref5[0], setForgotPassStep = ref5[1];
    var handleBack = function() {
        if (forgotPassStep === 0) {
            router.push((0,general/* sanitizeURL */.lz)(backLink));
            return;
        }
        if (forgotPassStep === 2) {
            setVisibleConfirmModal(true);
            return;
        }
        // @ts-expect-error
        setForgotPassStep(forgotPassStep - 1);
    };
    var submitEmail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return requestOTP(function() {
                            return setForgotPassStep(1);
                        });
                    case 3:
                        _ctx.next = 9;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        if ((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.cause) === null || ref === void 0 ? void 0 : ref.errorType) === "OTP_LIMIT_EXCEEDED") {
                            setShowModalBlocked(true);
                        } else {
                            ;
                            (0,AlertMessage/* default */.Z)({
                                content: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message,
                                messageType: "error",
                                alertType: "snackbar"
                            });
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function submitEmail() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        resetError();
    }, [
        forgotPassStep
    ]);
    var renderCardTitle = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            align: "center",
            style: {
                gap: 8
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: forgotPassStep > 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "icon/chevron-left.svg",
                        onClick: handleBack,
                        size: "12px",
                        style: {
                            cursor: "pointer"
                        },
                        "data-cy": "change-index-back-button"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    weight: "700",
                    size: "18px",
                    children: "Forgot Password"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* EditProfileCard */.pr, {
        variant: "profile-config",
        title: renderCardTitle(),
        id: "setting-password",
        "data-cy": "change-index-form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBlockedReqOTP/* default */.Z, {
                visible: showModalBlocked,
                title: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalNavigateConfirmation/* default */.Z, {
                visible: visibleConfirmModal,
                onStay: function() {
                    return setVisibleConfirmModal(false);
                },
                onLeave: function() {
                    return router.push("/login");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalSuccess/* default */.Z, {
                visible: successCreatePassword,
                onLogout: function() {
                    return router.push("/login");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: forgotPassStep === 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionEmailField, {
                    title: "Enter Your Email",
                    subTitle: "Enter your registered email address on Stockbit to create new password",
                    onSubmit: submitEmail,
                    preventSubmit: isSubmitting || email === "",
                    inputPlaceHolder: "Enter Registered Email",
                    submitText: "Continue",
                    email: email,
                    setEmail: setEmail
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: forgotPassStep === 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionOTPField/* default */.Z, {
                    setOtpConfig: setOtpConfig,
                    otpLength: config/* OTP_LENGTH */.c,
                    otpConfig: otpConfig,
                    otpData: otpData,
                    preventSubmit: isSubmitting || ((ref = otpConfig.otp) === null || ref === void 0 ? void 0 : ref.length) < config/* OTP_LENGTH */.c,
                    onSubmit: function() {
                        return verifyOTP(function() {
                            return setForgotPassStep(2);
                        });
                    },
                    onRequestOTP: requestOTP,
                    requestOTPOnload: false,
                    multipleOTPMethodAvailable: false,
                    submitText: "Continue",
                    error: error,
                    resetError: resetError
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: forgotPassStep === 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(change_forgot_password_SectionPasswordField/* default */.Z, {
                    title: "Create New Password",
                    subTitle: "Create a strong password with a mix of numbers & uppercase and lowercase letters.",
                    passwordValidation: passwordValidation,
                    password: password.new,
                    onChangePassword: function(n) {
                        return setPassword((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, password), {
                            new: n
                        }));
                    },
                    onSubmit: function() {
                        return submitNewPassword(function() {
                            return setForgotPassStep(3);
                        });
                    },
                    submitText: "Continue",
                    inputPlaceHolder: "Enter New Password",
                    preventSubmit: isSubmitting || !password.new || !Object.values(passwordValidation).every(function(value) {
                        return value === true;
                    }) || Boolean(error),
                    error: error
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: forgotPassStep === 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(change_forgot_password_SectionPasswordField/* default */.Z, {
                    title: "Confirm Your Password",
                    subTitle: "Enter your password again to confirm.",
                    onSubmit: function() {
                        return submitConfirmPassword(function() {
                            return setSuccessCreatePassword(true);
                        });
                    },
                    submitText: "Continue",
                    inputPlaceHolder: "Re-enter New Password",
                    password: password.confirm,
                    onChangePassword: function(c) {
                        return setPassword((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, password), {
                            confirm: c
                        }));
                    },
                    preventSubmit: isSubmitting || !password.confirm || Boolean(error),
                    error: error
                })
            })
        ]
    });
}
/* harmony default export */ var ForgotPasswordNonLoginSteps = (ForgotPasswordSteps);

// EXTERNAL MODULE: ./src/features/change-forgot-password/styled.ts
var change_forgot_password_styled = __webpack_require__(82127);
;// CONCATENATED MODULE: ./pages/forgotpassword.tsx

__webpack_require__(14473);



function ForgotPasswordPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Stockbit - Forgot Password"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(change_forgot_password_styled/* GuestLayout */.HF, {
                noBox: true,
                isCompanyStock: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPasswordNonLoginSteps, {})
            })
        ]
    });
}
/* harmony default export */ var forgotpassword = (ForgotPasswordPage);


/***/ }),

/***/ 22147:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Color name source http://www.htmlcsscolor.com/
 */ /* harmony default export */ __webpack_exports__["Z"] = ({
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7",
    yellowSea: "#eba031",
    chardonnay: "#ffc774",
    softgreen: "#E5F7F0",
    mountainMeadow: "#0bba7a",
    grey: "#777777",
    nero: "#222222",
    ghostWhite: "#f8f8f9",
    azureBlue: "#2F8EF7",
    bitterSweet: "#fc605c",
    supernova: "#fdbc40",
    limeGreen: "#34c84a",
    softGainsboro: "#DDDDDD",
    mediumAquamarine: "#5dcbad",
    cosmicLatte: "#e1f6e5",
    vividViolet: "#712E9E"
});


/***/ }),

/***/ 74575:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    mobileS: "(min-width:320px)",
    mobileM: "(min-width:375px)",
    mobileL: "(min-width:425px)",
    tablet: "(min-width:768px)",
    laptop: "(min-width:1024px)",
    laptopL: "(min-width:1440px)",
    desktop: "(min-width:2560px)"
});


/***/ }),

/***/ 94526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49288);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  border: none;\n  cursor: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var OptionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-773c3636-0"
})(_templateObject());
var OptionRender = function(options) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OptionsWrapper, {
        children: options
    });
};
var AutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        filterOption: false,
        dropdownStyle: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset",
            minWidth: "260px",
            width: "auto"
        }, props.dropdownStyles),
        dropdownRender: props.dropdownRender || OptionRender,
        width: props.width || "100%",
        bordered: props.bordered || false
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-773c3636-1"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);


/***/ }),

/***/ 57788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  margin: ",
        ";\n  ",
        "\n  & > img {\n    background: ",
        ";\n    width: ",
        ";\n    height: ",
        ";\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var avatarSize = {
    "x-small": "30px",
    small: "40px",
    medium: "50px",
    large: "70px",
    "x-large": "100px",
    "xx-large": "120px"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "100%",
        padding: props.padding || 0,
        margin: props.margin || 0
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-a4069f0d-0"
})(_templateObject1(), function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lowgray */ .Z.lowgray, function(props) {
    return avatarSize[props.size];
}, function(props) {
    return avatarSize[props.size];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].component */ .Z.component));


/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ',
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-b792a68c-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 81301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97751);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-card-head-title {\n      display: flex;\n      align-items: center;\n      font-size: 18px;\n      font-weight: 400;\n      color: ",
        ";\n    }\n\n    .ant-card-extra {\n      font-size: 18px;\n      text-align: right;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        background-color: ",
        ";\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  flex-direction: column;\n  width: ",
        ";\n\n  .ant-card-head {\n    padding: ",
        ";\n    ",
        "\n  }\n\n  .ant-card-head-title {\n    display: flex;\n    align-items: center;\n  }\n\n  .ant-card-body {\n    padding: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var variants = {
    "profile-config": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary)
};
var Card = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        variant: props.variant || false,
        headerBackground: props.headerBackground,
        width: props.width || "100%",
        bodyPadding: props.bodyPadding || "20px",
        headPadding: props.headPadding || "0 20px",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-5f118f4a-0"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var headPadding = param.headPadding;
    return headPadding;
}, function(param) {
    var headerBackground = param.headerBackground;
    return headerBackground && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), headerBackground);
}, function(param) {
    var bodyPadding = param.bodyPadding;
    return bodyPadding;
}, function(param) {
    var variant = param.variant;
    return variant && variants[variant];
});
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 81190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-checkbox-checked .ant-checkbox-inner {\n      background-color: unset;\n      border-color: ",
        ";\n    }\n\n    .ant-checkbox-checked .ant-checkbox-inner::after {\n      border-color: ",
        ";\n      border-width: 1px;\n    }\n\n    .ant-checkbox-input:focus + .ant-checkbox-inner {\n      border-color: ",
        ";\n    }\n\n    :hover .ant-checkbox-inner {\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-checkbox-checked .ant-checkbox-inner {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n\n    :hover .ant-checkbox-inner,\n    .ant-checkbox-input:focus + .ant-checkbox-inner {\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n\n  .ant-checkbox-checked::after {\n    content: unset;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var checkboxTheme = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro),
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary)
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        height: props.height,
        width: props.width,
        checkboxType: props.checkboxType,
        centered: props.centered
    };
}).withConfig({
    componentId: "sc-155ef71a-0"
})(_templateObject3(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var checkboxType = param.checkboxType;
    return checkboxTheme[checkboxType];
}, function(param) {
    var centered = param.centered;
    return centered && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2());
}));


/***/ }),

/***/ 70420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35851);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  border: 1px solid ',
        " !important;\n  border-color: ",
        " !important;\n  box-shadow: none !important;\n\n  :hover,\n  :focus {\n    border: 1px solid ",
        " !important;\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c892a315-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro));


/***/ }),

/***/ 8089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h_": function() { return /* binding */ DropdownMenu; }
/* harmony export */ });
/* unused harmony export MoreIcon */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58928);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38504);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_hexOpacity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84607);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  margin: 2.5px 5px 2.5px 7.5px;\n  width: 5px;\n  height: 5px;\n  border: 1px solid ",
        ";\n  border-radius: 50px;\n  float: none;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0px !important;\n  border-right: none;\n  width: 256px;\n\n  li {\n    height: 30px;\n    line-height: 30px;\n    padding: 0 10px;\n    font-size: 14px;\n  }\n\n  li:hover {\n    background: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n  }\n\n  .ant-dropdown-menu-item .ant-dropdown-menu-item-only-child {\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var MoreIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-cd7a91fb-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray);
var Menu = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cd7a91fb-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
var MenuItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Item */ .Z.Item).withConfig({
    componentId: "sc-cd7a91fb-2"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro + (0,_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(80));
var Dropdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cd7a91fb-3"
})(_templateObject3());
Dropdown.Menu = Menu;
Dropdown.Menu.Item = MenuItem;
Dropdown.MoreIcon = MoreIcon;
var DropdownMenu = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, Menu), {
    Item: MenuItem
});

/* harmony default export */ __webpack_exports__["ZP"] = (Dropdown);


/***/ }),

/***/ 70821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  flex-wrap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Flex = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        direction: props.direction || "row",
        justify: props.justify || "left",
        align: props.align || "flex-start",
        padding: props.padding || "0",
        margin: props.margin || "0",
        width: props.width,
        height: props.height,
        wrap: props.wrap || "nowrap"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c038202d-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var wrap = param.wrap;
    return wrap;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (Flex);


/***/ }),

/***/ 37949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  background: url(",
        ") center center/ ",
        " auto no-repeat;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        icon: props.icon || "",
        iconSize: props.iconSize || "12px",
        padding: props.padding || "unset",
        width: props.width || "12px",
        height: props.height || "12px",
        margin: props.margin || "unset"
    };
}).withConfig({
    componentId: "sc-8b5a1fc1-0"
})(_templateObject(), function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var iconSize = param.iconSize;
    return iconSize;
}, function(param) {
    var iconSize = param.iconSize;
    return iconSize;
}, function(param) {
    var icon = param.icon;
    return icon;
}, function(param) {
    var iconSize = param.iconSize;
    return iconSize;
}));


/***/ }),

/***/ 48253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* eslint-disable react/jsx-props-no-spreading */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  & > div {\n    display: ",
        ";\n    width: 5px;\n    height: 5px;\n    margin: 2px;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "vertical"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        vertical: props.vertical
    };
}).withConfig({
    componentId: "sc-fadbb486-0"
})(_templateObject(), function(param) {
    var vertical = param.vertical;
    return vertical ? "block" : "inline-block";
}, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray);
var IconMoreOptions = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconMoreOptions);


/***/ }),

/***/ 15807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ IconWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  height: ",
        ";\n  width: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: ",
        ";\n  cursor : pointer;\n  \n  ::before {\n    content: '",
        "';\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 7%;\n    left: 7%;\n    color: ",
        ";\n    background: ",
        ";\n    border-radius: 50%;\n    min-width: 18px;\n    font-size: 12px;\n    font-weight: bold;\n    z-index: 2;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "icomoon";\n  font-size: ',
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin: 0;\n\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "auto",
        padding: props.padding || "0px",
        newItem: props.newItem || 0,
        justify: props.justify || "center"
    };
}).withConfig({
    componentId: "sc-793d8880-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var newItem = param.newItem;
    return newItem || "";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
var Iconmoon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.attrs */ .ZP.p.attrs(function(props) {
    return {
        size: props.size || "16px",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray,
        isActive: props.isActive || false,
        hoverColor: props.hoverColor || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
        weight: props.weight || "normal"
    };
}).withConfig({
    componentId: "sc-793d8880-1"
})(_templateObject1(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(props) {
    return !props.isActive ? props.color : _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary;
}, function(props) {
    return props.hoverColor;
});

/* harmony default export */ __webpack_exports__["Z"] = (Iconmoon);


/***/ }),

/***/ 54325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7648);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 22px;\n    font-weight: 600;\n    text-align: center;\n    height: 35px;\n    border: 1px solid ",
        ";\n    @media ",
        " {\n      width: 300px;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  height: ',
        ";\n  width: ",
        " !important;\n  margin: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n\n  .ant-input::placeholder {\n    color: ",
        ";\n    font-size: 13px;\n  }\n\n  :hover,\n  :focus,\n  :focus-within {\n    border-color: ",
        ";\n    outline-color: transparent;\n    box-shadow: none;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  height: ',
        ";\n  width: ",
        " !important;\n  margin: ",
        ";\n  border-color: ",
        ";\n\n  .ant-input::placeholder {\n    color: ",
        ";\n    font-size: 13px;\n  }\n\n  :hover,\n  :focus,\n  :focus-within {\n    border-color: ",
        ";\n    box-shadow: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var type = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject()),
    withdraw: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].laptop */ .Z.laptop)
};
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        height: props.height || "auto",
        width: props.width || "auto",
        margin: props.margin || "0",
        padding: props.padding || "5px",
        round: props.round || true,
        type: props.type || "basic"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-85b10eda-0"
})(_templateObject3(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var margin = param.margin;
    return margin;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var round = param.round;
    return round ? "2px" : "unset";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var typeKey = param.type;
    return type[typeKey];
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props));
});
Input.TextArea = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].TextArea */ .Z.TextArea).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        height: props.height || "auto",
        width: props.width || "100%",
        margin: props.margin || "0"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-85b10eda-1"
})(_templateObject5(), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var margin = param.margin;
    return margin;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 23906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95541);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0px;\n  background-color: transparent;\n  cursor: pointer;\n  transition: 0.2s;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  width: 100%;\n  position: relative;\n  background-color: ",
        ';\n  transition: 0.2s;\n\n  ::before {\n    content: "";\n    display: block;\n    position: absolute;\n    width: 0px;\n    height: 1px;\n    background-color: ',
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n\n  input {\n    position: inherit;\n    z-index: 1;\n    border: none;\n    background: transparent;\n  }\n\n  input::placeholder {\n    color: transparent;\n  }\n\n  input:focus {\n    outline: 0;\n  }\n\n  input:focus ~ ",
        ", input:not(:placeholder-shown) ~ ",
        " {\n    top: -20px;\n    font-size: 13px;\n  }\n\n  input:focus ~ ",
        "::before {\n    width: 100%;\n    transition: 0.5s;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var Label = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    height: "28px",
    color: _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].midgray */ .Z.midgray,
    size: "16px",
    as: "label"
}).withConfig({
    componentId: "sc-c91cfec7-0"
})(_templateObject());
var Bar = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        activeColorBars: props.activeColorBar
    };
}).withConfig({
    componentId: "sc-c91cfec7-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lowgray */ .Z.lowgray, function(param) {
    var activeColorBar = param.activeColorBar;
    return activeColorBar || _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary;
});
var Container = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c91cfec7-2"
})(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, Label, Label, Bar, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props));
});
var InputContainer = function(_param) {
    var children = _param.children, className = _param.className, activeColorBar = _param.activeColorBar, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "activeColorBar"
    ]);
    var childrenProps = children.props;
    var placeholder = childrenProps.placeholder;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: className
    }, otherProps), {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Bar, {
                activeColorBar: activeColorBar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                children: placeholder || " "
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InputContainer);


/***/ }),

/***/ 61645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ InputNumberContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69428);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* eslint-disable react/jsx-props-no-spreading */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  justify-content: space-between;\n  width: 160px;\n  @media ",
        " {\n    margin: 0 15px;\n  }\n\n  .ant-input-number-focused,\n  .ant-input-number:hover,\n  .ant-input-number {\n    border: none !important;\n    box-shadow: none !important;\n  }\n  .ant-input-number-handler-wrap {\n    opacity: 1;\n    height: 100%;\n    background: #fff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: none;\n  }\n  .ant-input-number-handler {\n    background: #f5f6f7;\n    height: 30px;\n    line-height: 30px;\n    display: inline-block;\n    width: 30px;\n  }\n\n  .ant-input-number-handler-up {\n    position: absolute;\n    left: 128px;\n    border-left: 1px solid ",
        ';\n    cursor: pointer;\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC");\n    }\n  }\n\n  .ant-input-number-handler-down {\n    border: none;\n    border-right: 1px solid ',
        ';\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==");\n    }\n  }\n  .ant-input-number-input {\n    text-align: center;\n  }\n\n  .ant-input-number-handler-up:hover,\n  .ant-input-number-handler-down,\n  .ant-input-number-handler-down:hover,\n  .ant-input-number-handler-up {\n    height: 30px !important;\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47fea7ce-0"
})(_templateObject());
var InputNumberContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-47fea7ce-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);

/* harmony default export */ __webpack_exports__["Z"] = (InputNumber);


/***/ }),

/***/ 63757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58928);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  margin: 2.5px 5px 2.5px 7.5px;\n  width: 5px;\n  height: 5px;\n  border: 1px solid ",
        ";\n  border-radius: 50px;\n  float: none;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0px;\n\n  li {\n    height: 28px;\n    line-height: 28px;\n    padding: 0 10px;\n    font-size: 14px;\n  }\n\n  li:hover {\n    background: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var MoreIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-d17ef6e0-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray);
var Menu = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d17ef6e0-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
Menu.MoreIcon = MoreIcon;
/* harmony default export */ __webpack_exports__["Z"] = (Menu);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 35266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56673);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n    .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    }\n\n    .ant-pagination-prev,\n    .ant-pagination-next {\n      border: 1px solid ",
        ";\n      a {\n        padding: 0 10px;\n      }\n    }\n\n    .ant-pagination-prev,\n    .ant-pagination-jump-prev,\n    .ant-pagination-jump-next {\n      margin-right: 0;\n      border: 1px solid ",
        ";\n    }\n\n    .ant-pagination-item {\n      margin-right: 0;\n      border-radius: 0;\n      border-color: ",
        ";\n\n      a {\n        color: ",
        ";\n        :hover {\n          color: ",
        ";\n        }\n      }\n    }\n\n    .ant-pagination-item-active {\n      a {\n        color: ",
        ";\n        font-weight: 600;\n      }\n      background: ",
        ";\n    }\n\n    .ant-pagination-prev:focus .ant-pagination-item-link,\n    .ant-pagination-next:focus .ant-pagination-item-link,\n    .ant-pagination-prev:hover .ant-pagination-item-link,\n    .ant-pagination-next:hover .ant-pagination-item-link {\n      border: 1px solid ",
        ";\n      color: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var type = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro)
};
var Pagination = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "basic"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-31bb62cf-0"
})(_templateObject2(), function(props) {
    return type[props.type];
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 70187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R_": function() { return /* binding */ PopoverContentWrapper; },
/* harmony export */   "xK": function() { return /* binding */ PopoverTitleWrapper; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  max-height: 400px;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  height: 40px;\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 360px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var PopoverContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        padding: props.padding || 0
    };
}).withConfig({
    componentId: "sc-b405b759-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var padding = param.padding;
    return padding;
});
var PopoverTitleWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b405b759-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var PopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b405b759-2"
})(_templateObject2());

/* harmony default export */ __webpack_exports__["ZP"] = (antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);


/***/ }),

/***/ 6305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92961);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  ",
        "\n\n  .ant-select-selector {\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    height: inherit !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Select = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: props.width
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8dcb9882-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 77148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79931);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-table-thead > tr > th {\n      background: ",
        ";\n    }\n\n    .ant-table-tbody > tr > td {\n      padding: 8px 15px;\n    }\n\n    .ant-table-column-sorter {\n      position: absolute;\n      right: 0;\n    }\n\n    .ant-table-column-sorter-up,\n    .ant-table-column-sorter-down {\n      display: none;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover {\n      background-color: unset;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-up,\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-down {\n      display: block;\n    }\n\n    .ant-table-column-sorter-up.active,\n    .ant-table-column-sorter-down.active {\n      color: ",
        ";\n      display: block;\n    }\n\n    .ant-empty-image {\n      display: none;\n    }\n\n    .ant-empty-normal {\n      margin: unset;\n    }\n\n    .ant-table-ping-left .ant-table-cell-fix-left-last::after {\n      box-shadow: unset;\n    }\n\n    .ant-table-container::after {\n      content: unset;\n    }\n\n    .ant-pagination-prev {\n      margin: unset;\n    }\n    .ant-pagination-item {\n      display: none;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var variants = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis)
};
var Table = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        variant: props.variant || "basic"
    };
}).withConfig({
    componentId: "sc-24c3e4c6-0"
})(_templateObject1(), function(param) {
    var variant = param.variant;
    return variants[variant];
});
/* harmony default export */ __webpack_exports__["Z"] = (Table);


/***/ }),

/***/ 12484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 0px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        veryLightGrey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-74ce45aa-0"
})(_templateObject9(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-74ce45aa-1"
})(_templateObject10(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 50864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: none;\n  outline: 0 !important;\n\n  .selected-flag {\n    height: 35px;\n    border: 1px solid ",
        ";\n    outline: 0;\n  }\n\n  > .react-tel-input.country-list {\n    list-style: none;\n    position: absolute !important;\n    z-index: 500 !important;\n    padding: 0;\n    margin: -1px 0 0 -1px;\n    background-color: ",
        ';\n    width: 310px;\n    max-height: 200px;\n    overflow-y: scroll;\n    border-radius: 0 0 3px 3px;\n    top: 34px;\n  }\n\n  input[type="tel"] {\n    outline: 0;\n    line-height: 35px;\n    height: 35px;\n    font-weight: 300;\n    width: 100%;\n    border: none;\n    font-size: 20px;\n    position: relative;\n    border-bottom: 1px solid ',
        ';\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  input[type="tel"]:focus,\n  input[type="text"]:focus {\n    border-color: ',
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TelephoneInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default())).withConfig({
    componentId: "sc-dcb2dc87-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary);
/* harmony default export */ __webpack_exports__["Z"] = (TelephoneInput);


/***/ }),

/***/ 95541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  padding: ",
        ";\n  width: ",
        ";\n  text-transform: ",
        ";\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  & > a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var familyType = {
    regular: "ProximaNovaRg",
    light: "ProximaNovaLt",
    bold: "ProximaNovaBd"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "ellipsis",
            "textTransform"
        ].includes(prop);
    }
}).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "14px",
        weight: props.weight || "normal",
        height: props.height || "normal",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis,
        align: props.align || "left",
        padding: props.padding || 0,
        width: props.width,
        ellipsis: props.ellipsis,
        textTransform: props.textTransform,
        family: props.family || "regular"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8a078c1d-0"
})(_templateObject3(), function(param) {
    var family = param.family;
    return familyType[family];
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(param) {
    var height = param.height;
    return height;
}, function(props) {
    return props.color;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var textTransform = param.textTransform;
    return textTransform;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var ellipsis = param.ellipsis;
    return ellipsis && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}));


/***/ }),

/***/ 39211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56266);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71cb950b-0"
})(_templateObject()));


/***/ }),

/***/ 48308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XZ": function() { return /* reexport */ Checkbox/* default */.Z; },
  "kC": function() { return /* reexport */ Flex/* default */.Z; },
  "u_": function() { return /* reexport */ Modal/* default */.Z; },
  "xv": function() { return /* reexport */ Text/* default */.Z; }
});

// UNUSED EXPORTS: Autocomplete, Avatar, Button, Card, Collapse, DatePicker, Dropdown, IconBase64, IconMoreOptions, IconWrapper, Iconmoon, Input, InputContainer, InputNumber, InputNumberContainer, Menu, Pagination, Popover, PopoverContent, PopoverContentWrapper, PopoverTitleWrapper, Radio, Select, Steps, Table, Tabs, Tag, TelephoneInput, Textarea, Tooltip

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/DatePicker.js
var DatePicker = __webpack_require__(70420);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconMoreOptions.js
var IconMoreOptions = __webpack_require__(48253);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconBase64.js
var IconBase64 = __webpack_require__(37949);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/InputForm.js
var InputForm = __webpack_require__(23906);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/InputNumber.js
var InputNumber = __webpack_require__(61645);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Card.js
var Card = __webpack_require__(81301);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Select.js
var Select = __webpack_require__(6305);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Autocomplete.js
var Autocomplete = __webpack_require__(94526);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 3 modules
var react_textarea_autosize_browser_esm = __webpack_require__(93463);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/hoc/withSpacing.js
var withSpacing = __webpack_require__(97214);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Textarea.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  width: 100%;\n  resize: none;\n\n  :focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Textarea = (0,styled_components_browser_esm/* default */.ZP)(react_textarea_autosize_browser_esm/* default */.Z).withConfig({
    componentId: "sc-d3c3a5a9-0"
})(_templateObject(), color/* default.gainsboro */.Z.gainsboro);
/* harmony default export */ var common_Textarea = ((0,withSpacing/* default */.Z)(Textarea));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Dropdown.js
var Dropdown = __webpack_require__(8089);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/TelephoneInput.js
var TelephoneInput = __webpack_require__(50864);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Menu.js
var Menu = __webpack_require__(63757);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Checkbox.js
var Checkbox = __webpack_require__(81190);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 15 modules
var tabs = __webpack_require__(76750);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Tabs.js

function Tabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Tabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .ant-tabs-nav {\n      margin: 0;\n    }\n\n    .ant-tabs-nav-list {\n      width: 100%;\n    }\n    .ant-tabs-tab {\n      margin-right: 0px !important;\n      width: 100%;\n      text-align: center;\n      display: block;\n      font-size: 16px;\n      :hover {\n        color: ",
        ";\n      }\n    }\n\n    .ant-tabs-nav .ant-tabs-nav-list {\n      border: 1px solid ",
        ";\n    }\n\n    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,\n    .ant-tabs-tab .ant-tabs-tab-active {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var variants = {
    basic: (0,styled_components_browser_esm/* css */.iv)(Tabs_templateObject()),
    "full-width": (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), color/* default.highempahis */.Z.highempahis, color/* default.whiteSmoke */.Z.whiteSmoke, color/* default.highempahis */.Z.highempahis)
};
var Tabs = (0,styled_components_browser_esm/* default */.ZP)(tabs/* default */.Z).attrs(function(props) {
    return {
        variant: props.variant || "basic"
    };
}).withConfig({
    componentId: "sc-ccea26c3-0"
})(_templateObject2(), function(param) {
    var variant = param.variant;
    return variants[variant];
});
/* harmony default export */ var common_Tabs = ((/* unused pure expression or super */ null && (Tabs)));

// EXTERNAL MODULE: ./node_modules/antd/es/collapse/index.js + 6 modules
var collapse = __webpack_require__(54907);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Collapse.js

function Collapse_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n\n    .ant-collapse-header {\n      color: ",
        ";\n    }\n  "
    ]);
    Collapse_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Collapse_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Collapse_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var types = {
    basic: (0,styled_components_browser_esm/* css */.iv)(Collapse_templateObject(), color/* default.light */.Z.light, color/* default.nightRider */.Z.nightRider)
};
var Collapse = (0,styled_components_browser_esm/* default */.ZP)(collapse/* default */.Z).attrs(function(props) {
    return {
        type: props.type || "basic"
    };
}).withConfig({
    componentId: "sc-291816d3-0"
})(Collapse_templateObject1(), function(param) {
    var type = param.type;
    return types[type];
});
/* harmony default export */ var common_Collapse = ((/* unused pure expression or super */ null && (Collapse)));

// EXTERNAL MODULE: ./node_modules/antd/es/steps/index.js + 3 modules
var steps = __webpack_require__(91756);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Steps.js

function Steps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-steps-item-process .ant-steps-item-icon {\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    Steps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Steps = (0,styled_components_browser_esm/* default */.ZP)(steps/* default */.Z).withConfig({
    componentId: "sc-8b4bf621-0"
})(Steps_templateObject(), color/* default.primary */.Z.primary, color/* default.primary */.Z.primary);
/* harmony default export */ var common_Steps = ((/* unused pure expression or super */ null && (Steps)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Table.js
var Table = __webpack_require__(77148);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Pagination.js
var Pagination = __webpack_require__(35266);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tooltip.js
var Tooltip = __webpack_require__(39211);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Radio.js

function Radio_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-radio-inner {\n    background-color: ",
        ";\n  }\n  .ant-radio-wrapper:hover .ant-radio,\n  .ant-radio:hover .ant-radio-inner,\n  .ant-radio-input:focus + .ant-radio-inner,\n  .ant-radio-checked .ant-radio-inner {\n    background-color: ",
        ";\n  }\n  .ant-radio-checked .ant-radio-inner {\n    border-color: ",
        ";\n  }\n  .ant-radio-inner::after {\n    background-color: ",
        ";\n  }\n"
    ]);
    Radio_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ var Radio = ((0,styled_components_browser_esm/* default */.ZP)(es_radio/* default */.ZP).withConfig({
    componentId: "sc-8f5670d5-0"
})(Radio_templateObject(), color/* default.veryLightGrey */.Z.veryLightGrey, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.light */.Z.light));

;// CONCATENATED MODULE: ./src/@deprecated-ui/common/index.js


































/***/ }),

/***/ 97214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var withSpacing = function(Component) {
    return function(props) {
        var spacing = (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props);
        var WithSpacingComponent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(Component).attrs(function(componentProps) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, componentProps, spacing);
        }).withConfig({
            componentId: "sc-bfeb3364-0"
        })(_templateObject1(), function(componentProps) {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(componentProps));
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WithSpacingComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withSpacing);


/***/ }),

/***/ 60227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConfigNavigationItem */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-right: 5px solid ",
        ";\n      background: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  border: 1px solid ",
        ";\n  border-bottom: 0 solid;\n  transition: background 0.3s;\n  background: ",
        ";\n  cursor: pointer;\n  position: relative;\n  height: ",
        ";\n\n  :hover {\n    transition: background 0.3s;\n    background: ",
        ";\n    border-right: 5px solid ",
        ";\n  }\n\n  :first-of-type {\n    border-radius: 2px 2px 0 0;\n  }\n\n  :last-of-type {\n    border-radius: 0 0 2px;\n    border-bottom: 1px solid ",
        ";\n  }\n\n  > * {\n    color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ConfigNavigationItem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].li.attrs */ .ZP.li.attrs(function(props) {
    return {
        isActive: props.isActive || false,
        height: props.height || "40px"
    };
}).withConfig({
    componentId: "sc-46da6bf5-0"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, function(param) {
    var height = param.height;
    return height;
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].aliceBlue */ .Z.aliceBlue);
});
ConfigNavigationItem.propTypes = {
    isActive: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
ConfigNavigationItem.defaultProps = {
    isActive: false,
    height: "40px"
};
/* harmony default export */ __webpack_exports__["Z"] = (ConfigNavigationItem);


/***/ }),

/***/ 16484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vt": function() { return /* reexport */ profile_ConfigNavigation; },
  "SS": function() { return /* reexport */ ConfigNavigationItem/* default */.Z; },
  "Bo": function() { return /* reexport */ profile_ProfileCollapse; },
  "iU": function() { return /* reexport */ profile_ProfileNotificationCheckGroup; },
  "IH": function() { return /* reexport */ profile_ProfileSwitch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/switch/index.js + 1 modules
var es_switch = __webpack_require__(94594);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/@deprecated-ui/profile/ProfileSwitch.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border: 1px solid ",
        ";\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n\n  :focus {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n\n  .ant-switch-handle {\n    border-radius: 50%;\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ProfileSwitch = (0,styled_components_browser_esm/* default */.ZP)(es_switch/* default */.Z).withConfig({
    componentId: "sc-f9047c38-0"
})(_templateObject1(), color/* default.gainsboro */.Z.gainsboro, color/* default.light */.Z.light, function(param) {
    var checked = param.checked;
    return checked && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), color/* default.primary */.Z.primary);
});
/* harmony default export */ var profile_ProfileSwitch = (ProfileSwitch);

// EXTERNAL MODULE: ./node_modules/antd/es/collapse/index.js + 6 modules
var collapse = __webpack_require__(54907);
;// CONCATENATED MODULE: ./src/@deprecated-ui/profile/ProfileCollapse.js

function ProfileCollapse_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  width: 100%;\n\n  .ant-collapse-header {\n    line-height: 40px;\n    font-size: 16px;\n    color: ",
        ";\n    font-weight: 600;\n    padding: 12px 0;\n  }\n\n  .ant-collapse-item {\n    :last-child {\n      border-bottom: none;\n    }\n  }\n"
    ]);
    ProfileCollapse_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ProfileCollapse = (0,styled_components_browser_esm/* default */.ZP)(collapse/* default */.Z).attrs(function() {
    return {
        defaultActiveKey: [
            "1"
        ],
        expandIconPosition: "right",
        bordered: false,
        accordion: true
    };
}).withConfig({
    componentId: "sc-1ae32541-0"
})(ProfileCollapse_templateObject(), color/* default.nightRider */.Z.nightRider);
/* harmony default export */ var profile_ProfileCollapse = (ProfileCollapse);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/index.js + 5 modules
var common = __webpack_require__(48308);
;// CONCATENATED MODULE: ./src/@deprecated-ui/profile/ProfileNotificationCheckGroup.js

function ProfileNotificationCheckGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  margin-bottom: 20px;\n  border: none;\n\n  span {\n    font-size: 12px;\n    font-weight: normal;\n    color: ",
        ";\n\n    border-bottom: 1px solid ",
        ";\n\n    width: 100%;\n    padding: 10px 0;\n  }\n\n  > div {\n    border-bottom: 1px solid ",
        ";\n  }\n  margin-bottom: 12px;\n"
    ]);
    ProfileNotificationCheckGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ProfileNotificationCheckGroup = (0,styled_components_browser_esm/* default */.ZP)(common/* Flex */.kC).attrs(function() {
    return {
        direction: "column",
        width: "100%"
    };
}).withConfig({
    componentId: "sc-c833001d-0"
})(ProfileNotificationCheckGroup_templateObject(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro, color/* default.primary */.Z.primary, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro);
/* harmony default export */ var profile_ProfileNotificationCheckGroup = (ProfileNotificationCheckGroup);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/@deprecated-ui/profile/ConfigNavigation.js

function ConfigNavigation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  padding: 0;\n  margin: 30px 0 0;\n\n  width: ",
        ";\n"
    ]);
    ConfigNavigation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ConfigNavigation = styled_components_browser_esm/* default.ul.attrs */.ZP.ul.attrs(function(props) {
    return {
        width: props.width || "180px"
    };
}).withConfig({
    componentId: "sc-e44bb7f8-0"
})(ConfigNavigation_templateObject(), function(param) {
    var width = param.width;
    return width;
});
ConfigNavigation.propTypes = {
    width: (prop_types_default()).string
};
ConfigNavigation.defaultProps = {
    width: "180px"
};
/* harmony default export */ var profile_ConfigNavigation = (ConfigNavigation);

// EXTERNAL MODULE: ./src/@deprecated-ui/profile/ConfigNavigationItem.js
var ConfigNavigationItem = __webpack_require__(60227);
;// CONCATENATED MODULE: ./src/@deprecated-ui/profile/index.js







/***/ }),

/***/ 52435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);




var types = {
    m: "margin",
    p: "padding"
};
var directions = {
    t: [
        "-top"
    ],
    r: [
        "-right"
    ],
    b: [
        "-bottom"
    ],
    l: [
        "-left"
    ],
    x: [
        "-left",
        "-right"
    ],
    y: [
        "-top",
        "-bottom"
    ]
};
var EMPTY_STRING = "";
var WHITE_SPACE = " ";
var REGEX = /^([mp][trblxy]?)$/;
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(prev, f) {
            return f(prev, x);
        }, x);
    };
};
var filter = function(keys) {
    return keys.filter(function(key) {
        return key.match(REGEX);
    });
};
var merge = function(props) {
    return props.map(function(param) {
        var type = param.type, direction = param.direction, value = param.value;
        return direction.map(function(d) {
            return "".concat(type).concat(d, ": ").concat(value, ";");
        }).join(WHITE_SPACE);
    });
};
var splitPropKey = function(keys, props) {
    return keys.map(function(key) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key.split(""), 2), type = ref[0], direction = ref[1];
        return {
            type: types[type],
            direction: directions[direction] || [
                EMPTY_STRING
            ],
            value: props[key]
        };
    });
};
var handleSpaces = function(props) {
    return pipe(Object.keys, filter, splitPropKey, merge)(props).join(WHITE_SPACE);
};
var spacingProps = function(props) {
    var typesKeys = Object.keys(types);
    var directionsKeys = Object.keys(directions);
    var result = typesKeys.map(function(type) {
        return directionsKeys.map(function(dir) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "".concat(type).concat(dir), props["".concat(type).concat(dir)]);
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(curr));
    }, []).filter(function(prop) {
        return Object.values(prop)[0];
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prev, curr);
    }, {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
/* harmony default export */ __webpack_exports__["Z"] = (handleSpaces);


/***/ }),

/***/ 84607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 *
 * @param {number} percentNum - accept value 0 until 100
 * eg:
 * import hexOpacity from "./hexOpacity";
 *
 * ...
 * ...
 *  color: ${color.primary + hexOpacity(80)}
 * ...
 *
 */ var percentToHex = function() {
    var percentNum = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return Math.round(percentNum / 100 * 255).toString(16).padStart(2, "0");
};
/* harmony default export */ __webpack_exports__["Z"] = (percentToHex);


/***/ }),

/***/ 60714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ APIErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
;// CONCATENATED MODULE: ./src/config/APIErrorMessage/handler.js





/**
 * handleDefault
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleDefault = function(errorType, message) {
    // Some API chat with 'blokir' message and 'FORBIDDEN' error_type should show alert
    // remove this block whenever BE possible to change error_type from 'FORBIDDEN'
    if (message.includes("blokir")) {
        var errMessageDefault = message;
        (0,AlertErrorMessage/* default */.Z)(errMessageDefault, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        return;
    }
    /// ///////////////////////////////////////////////////
    if (errorType === errorMessage/* default.PAYWALL_NOSUBSCRIPTION */.Z.PAYWALL_NOSUBSCRIPTION) return;
    if (errorType === errorMessage/* default.FORBIDDEN */.Z.FORBIDDEN) return;
    var errMessageDefault1 = message;
    (0,AlertErrorMessage/* default */.Z)(errMessageDefault1, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleMaintenance
 * web legacy: app\lib\Api.js line 184
 * @param {*} errorType | MAINTENANCE | ERROR_GATEWAY
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleMaintenance = function(errorType, message) {
    if (errorType === "MAINTENANCE" && message) {
        (0,utils/* dispatchSetErrorCode */.S)(503, message);
    }
};
/**
 * handleUnAuthorized
 * web legacy: app\lib\Api.js line 192
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleInvalidParameter = function(errorType, message) {
    if (errorType === "INVALID_RECAPTCHA") {
        return;
    }
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleInternalServerError
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ // eslint-disable-next-line no-unused-vars
var handleInternalServerError = function(_, message) {
    (0,utils/* dispatchSetErrorCode */.S)(500);
};
/**
 * handleNotFound
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotFound = function(_, message) {
    (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
};
/**
 * handleNotSubscription
 * web legacy: app\lib\Api.js line 238
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotSubscription = function() {
// TODO: url
};
/**
 * @deprecated 401 Unathorized is directly handled from API instance
 * handleUnAuthorized
 * @param {Promise} originalRequest
 * @return Promise originalRequest with new Authorization header or error rejection
 */ // eslint-disable-next-line @typescript-eslint/no-empty-function
var handleUnAuthorized = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(originalRequest) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleUnAuthorized(originalRequest) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var handler = ({
    handleDefault: handleDefault,
    handleMaintenance: handleMaintenance,
    handleInvalidParameter: handleInvalidParameter,
    handleNotFound: handleNotFound,
    handleNotSubscription: handleNotSubscription,
    handleUnAuthorized: handleUnAuthorized,
    handleInternalServerError: handleInternalServerError
});

;// CONCATENATED MODULE: ./src/config/APIErrorMessage/index.js

var APIErrorMessage_handleDefault = handler.handleDefault, APIErrorMessage_handleMaintenance = handler.handleMaintenance, APIErrorMessage_handleInvalidParameter = handler.handleInvalidParameter, APIErrorMessage_handleNotFound = handler.handleNotFound, APIErrorMessage_handleNotSubscription = handler.handleNotSubscription, APIErrorMessage_handleUnAuthorized = handler.handleUnAuthorized, APIErrorMessage_handleInternalServerError = handler.handleInternalServerError;
/**
 * Exodus API error message handler
 * @param {number} status - HTTP Response status | required
 * @param {string} errorType - Error types | required
 * @param {string} message - Error message | required
 */ var APIExodusErrorHandler = function(status, errorType, message) {
    var listErrorResponse = {
        DEFAULT: APIErrorMessage_handleDefault,
        400: APIErrorMessage_handleInvalidParameter,
        401: APIErrorMessage_handleUnAuthorized,
        402: APIErrorMessage_handleNotSubscription,
        404: APIErrorMessage_handleNotFound,
        500: APIErrorMessage_handleInternalServerError,
        503: APIErrorMessage_handleMaintenance
    };
    var response = listErrorResponse[status] || listErrorResponse.DEFAULT;
    return response(errorType, message);
};
/* harmony default export */ var APIErrorMessage = ({
    APIExodusErrorHandler: APIExodusErrorHandler
});


/***/ }),

/***/ 63858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ dispatchSetErrorCode; }
/* harmony export */ });
/* harmony import */ var global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73580);
/* eslint-disable import/prefer-default-export */ 
var dispatchSetErrorCode = function(errorCode) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setState */ .Z.setState({
        errorCode: errorCode,
        errorMessage: errorMessage
    });
};


/***/ }),

/***/ 14350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RL": function() { return /* binding */ getAccessTokenDataFn; },
/* harmony export */   "oD": function() { return /* binding */ getRefreshTokenConfigFn; },
/* harmony export */   "x5": function() { return /* binding */ refreshExodusToken; }
/* harmony export */ });
/* unused harmony export initialRefreshTokenConfig */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14229);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37213);





var initialRefreshTokenConfig = {
    refreshingTokenStatus: "initial",
    refreshAndRetryQueue: []
};
var getRefreshTokenConfigFn = function() {
    var initNewConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (true) {
        if (initNewConfig) {
            window.refreshRequestConfig = {
                refreshingTokenStatus: "initial",
                refreshAndRetryQueue: []
            };
            return window.refreshRequestConfig;
        }
        if (typeof window.refreshRequestConfig !== "undefined") {
            return window.refreshRequestConfig;
        }
        return undefined;
    }
    return initialRefreshTokenConfig;
};
var getAccessTokenDataFn = function() {
    var ref, ref1, ref2, ref3;
    var parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
    var accessToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.accessToken) === null || ref === void 0 ? void 0 : ref.token) || "";
    var accessTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.expiry) || 0;
    var refreshToken = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref2 = parsedToken.refresh) === null || ref2 === void 0 ? void 0 : ref2.token) || "";
    var refreshTokenExpiry = (parsedToken === null || parsedToken === void 0 ? void 0 : (ref3 = parsedToken.refresh) === null || ref3 === void 0 ? void 0 : ref3.expiry) || 0;
    return {
        accessToken: accessToken,
        accessTokenExpiry: accessTokenExpiry,
        refreshToken: refreshToken,
        refreshTokenExpiry: refreshTokenExpiry
    };
};
var refreshExodusToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, parsedToken, refreshToken, response, _data, newAccessTokenData, parsedAccessExpired, parsedRefreshExpired;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    parsedToken = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
                    refreshToken = parsedToken === null || parsedToken === void 0 ? void 0 : (ref = parsedToken.refresh) === null || ref === void 0 ? void 0 : ref.token;
                    _ctx.next = 5;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/login/refresh"), null, {
                        headers: {
                            Authorization: "Bearer ".concat(refreshToken)
                        }
                    });
                case 5:
                    response = _ctx.sent;
                    if (!(!response || !response.data || !response.data.data)) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 8:
                    _data = response.data, newAccessTokenData = _data.data;
                    parsedAccessExpired = new Date(newAccessTokenData.access.expired_at).getTime();
                    parsedRefreshExpired = new Date(newAccessTokenData.refresh.expired_at).getTime();
                    utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].saveToken */ .Z.saveToken({
                        accessToken: newAccessTokenData.access.token,
                        accessTokenExp: parsedAccessExpired,
                        refreshToken: newAccessTokenData.refresh.token,
                        refreshTokenExp: parsedRefreshExpired,
                        accessUser: utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserAccess */ .Z.getUserAccess()
                    });
                    return _ctx.abrupt("return", newAccessTokenData.access.token);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function refreshExodusToken() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 68425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ config_requestExodus; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/config/refreshToken/index.ts
/* eslint-disable no-param-reassign */ 

var generateNewRequestWithRefreshToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var apiInstance, axiosError, getRefreshTokenConfig, getAccessTokenData, refreshTokenPromise, refreshTokenConfig, dateNow, newAccessToken, newRequest;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    apiInstance = param.apiInstance, axiosError = param.axiosError, getRefreshTokenConfig = param.getRefreshTokenConfig, getAccessTokenData = param.getAccessTokenData, refreshTokenPromise = param.refreshTokenPromise;
                    refreshTokenConfig = getRefreshTokenConfig();
                    dateNow = Math.floor(Date.now() / 1000);
                    _ctx.prev = 3;
                    if (!(dateNow > getAccessTokenData().refreshTokenExpiry)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed Refresh Token");
                case 6:
                    if (!(typeof refreshTokenConfig === "undefined" || // Previous success refresh token config need to reset
                    (refreshTokenConfig.refreshingTokenStatus === "success" && dateNow > getAccessTokenData().accessTokenExpiry))) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", generateNewRequestWithRefreshToken({
                        apiInstance: apiInstance,
                        axiosError: axiosError,
                        getAccessTokenData: getAccessTokenData,
                        refreshTokenPromise: refreshTokenPromise,
                        getRefreshTokenConfig: function() {
                            return getRefreshTokenConfig(true);
                        }
                    }));
                case 8:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "initial")) {
                        _ctx.next = 22;
                        break;
                    }
                    refreshTokenConfig.refreshingTokenStatus = "processing";
                    ;
                    _ctx.prev = 11;
                    _ctx.next = 14;
                    return refreshTokenPromise();
                case 14:
                    newAccessToken = _ctx.sent;
                    refreshTokenConfig.refreshingTokenStatus = "success";
                    _ctx.next = 21;
                    break;
                case 18:
                    _ctx.prev = 18;
                    _ctx.t0 = _ctx["catch"](11);
                    throw new Error("Failed Refresh Token");
                case 21:
                    // After refresh token API call success,
                    // proceed every API call within queue
                    refreshTokenConfig.refreshAndRetryQueue.forEach(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                            var config, resolve, newRequest;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        config = param.config, resolve = param.resolve;
                                        config.headers.Authorization = "Bearer ".concat(newAccessToken);
                                        _ctx.prev = 2;
                                        _ctx.next = 5;
                                        return apiInstance.request(config);
                                    case 5:
                                        newRequest = _ctx.sent;
                                        resolve(newRequest);
                                        _ctx.next = 12;
                                        break;
                                    case 9:
                                        _ctx.prev = 9;
                                        _ctx.t0 = _ctx["catch"](2);
                                        throw new Error("Failed API call after success refresh token");
                                    case 12:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    2,
                                    9
                                ]
                            ]);
                        }));
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                case 22:
                    if (!(refreshTokenConfig.refreshingTokenStatus === "success")) {
                        _ctx.next = 30;
                        break;
                    }
                    if (!(axiosError.config.headers.Authorization === "Bearer ".concat(getAccessTokenData().accessToken))) {
                        _ctx.next = 25;
                        break;
                    }
                    throw new Error("Token Alreadry Refreshed");
                case 25:
                    // Proceed new incoming API call with new API token
                    axiosError.config.headers.Authorization = "Bearer ".concat(getAccessTokenData().accessToken);
                    _ctx.next = 28;
                    return apiInstance.request(axiosError.config);
                case 28:
                    newRequest = _ctx.sent;
                    return _ctx.abrupt("return", newRequest);
                case 30:
                    if (refreshTokenConfig.refreshingTokenStatus === "failed") {
                        refreshTokenConfig.refreshAndRetryQueue.forEach(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, index) {
                                var reject;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            reject = param.reject;
                                            reject(axiosError);
                                            if (index === refreshTokenConfig.refreshAndRetryQueue.length - 1) {
                                                refreshTokenConfig.refreshAndRetryQueue = [];
                                            }
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(_, index) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    }
                    _ctx.next = 37;
                    break;
                case 33:
                    _ctx.prev = 33;
                    _ctx.t1 = _ctx["catch"](3);
                    if (typeof refreshTokenConfig !== "undefined") {
                        refreshTokenConfig.refreshingTokenStatus = "failed";
                    }
                    return _ctx.abrupt("return", Promise.reject(_ctx.t1));
                case 37:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        getRefreshTokenConfig().refreshAndRetryQueue.push({
                            config: axiosError.config,
                            resolve: resolve,
                            reject: reject
                        });
                    }));
                case 38:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                33
            ],
            [
                11,
                18
            ]
        ]);
    }));
    return function generateNewRequestWithRefreshToken(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var refreshToken = (generateNewRequestWithRefreshToken);

// EXTERNAL MODULE: ./src/config/refreshToken/exodus.ts
var exodus = __webpack_require__(14350);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/utils.ts
var utils = __webpack_require__(63858);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/index.js + 1 modules
var APIErrorMessage = __webpack_require__(60714);
;// CONCATENATED MODULE: ./src/config/requestExodus.ts















var APIExodusErrorHandler = APIErrorMessage/* default.APIExodusErrorHandler */.Z.APIExodusErrorHandler;
function requestExodus() {
    var isShowAlertMessage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, customUserAgent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraHeaders = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var headers = (0,_object_spread/* default */.Z)({
        Accept: "application/json"
    }, extraHeaders);
    if (customUserAgent) {
        headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
            "User-Agent": api/* CUSTOM_USER_AGENT */.GV
        });
    }
    var apiInstance = axios_default().create({
        baseURL: api/* API_EXODUS_URL */.q7,
        headers: headers
    });
    apiInstance.interceptors.request.use(function(request) {
        var ref, ref1;
        var requestFromBrowser = (0,app/* isClient */.C5)();
        if (!requestFromBrowser) {
            return request;
        }
        if (!(window === null || window === void 0 ? void 0 : (ref = window.navigator) === null || ref === void 0 ? void 0 : ref.onLine)) {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.OFFLINE */.Z.OFFLINE, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
            return Promise.reject(errorMessage/* default.OFFLINE */.Z.OFFLINE);
        }
        // Custom Authorization Header Exist
        if (request.headers.Authorization) {
            return request;
        }
        // Default Authorization
        var parsedToken = auth/* default.getToken */.Z.getToken();
        var token = parsedToken === null || parsedToken === void 0 ? void 0 : (ref1 = parsedToken.accessToken) === null || ref1 === void 0 ? void 0 : ref1.token;
        if (request.url !== "/user/setting/password/reset" && token) {
            // eslint-disable-next-line no-param-reassign
            request.headers.Authorization = "Bearer ".concat(token);
        }
        return request;
    }, function(error) {
        return Promise.reject(error);
    });
    apiInstance.interceptors.response.use(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            var responseRetrieveFromBrowser, _data, errorType, _message, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", response);
                    case 3:
                        _data = response.data, errorType = _data.error_type, _message = _data.message, message = _message === void 0 ? errorMessage/* default.DEFAULT_ERROR_MESSAGE */.Z.DEFAULT_ERROR_MESSAGE : _message;
                        if (!(errorType && isShowAlertMessage)) {
                            _ctx.next = 7;
                            break;
                        }
                        (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        throw message;
                    case 7:
                        return _ctx.abrupt("return", response);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(axiosError) {
            var ref, ref1, ref2, ref3, responseRetrieveFromBrowser, newRequest, _response, status, data, message, errorType, errors, parsedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        responseRetrieveFromBrowser = (0,app/* isClient */.C5)();
                        if (responseRetrieveFromBrowser) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 4:
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(axiosError));
                    case 6:
                        //-------------------------------------------
                        // Error Logger
                        (0,logger/* sentryLog */.gB)({
                            scope: "server-layer",
                            level: "info",
                            httpStatusCode: (ref = axiosError.response) === null || ref === void 0 ? void 0 : ref.status,
                            tags: [
                                {
                                    title: "api-error-url",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref1 = axiosError.request) === null || ref1 === void 0 ? void 0 : ref1.responseURL
                                },
                                {
                                    title: "api-error-text",
                                    value: axiosError === null || axiosError === void 0 ? void 0 : (ref2 = axiosError.request) === null || ref2 === void 0 ? void 0 : ref2.responseText
                                }, 
                            ],
                            error: new Error(axiosError.message)
                        });
                        if (![
                            401
                        ].includes((ref3 = axiosError.response) === null || ref3 === void 0 ? void 0 : ref3.status)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return refreshToken({
                            apiInstance: apiInstance,
                            axiosError: axiosError,
                            getRefreshTokenConfig: exodus/* getRefreshTokenConfigFn */.oD,
                            getAccessTokenData: exodus/* getAccessTokenDataFn */.RL,
                            refreshTokenPromise: exodus/* refreshExodusToken */.x5
                        });
                    case 11:
                        newRequest = _ctx.sent;
                        return _ctx.abrupt("return", newRequest);
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](8);
                        (0,utils/* dispatchSetErrorCode */.S)(401);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 19:
                        _response = axiosError.response, status = _response.status, data = _response.data;
                        message = data === null || data === void 0 ? void 0 : data.message;
                        errorType = data === null || data === void 0 ? void 0 : data.error_type;
                        errors = (data === null || data === void 0 ? void 0 : data.errors) || [];
                        // Some error message is unparsed in `message`
                        if (!errorType) {
                            parsedMessage = JSON.parse(message);
                            message = parsedMessage.message;
                            errorType = parsedMessage.error_type;
                        }
                        if (isShowAlertMessage) {
                            _ctx.next = 26;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(new Error(axiosError.message, {
                            cause: {
                                status: status,
                                message: message,
                                errorType: errorType,
                                errors: errors
                            }
                        })));
                    case 26:
                        APIExodusErrorHandler(status, errorType, message);
                        return _ctx.abrupt("return", Promise.reject(new Error(axiosError.message, {
                            cause: {
                                status: status,
                                message: message,
                                errorType: errorType,
                                errors: errors
                            }
                        })));
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    15
                ]
            ]);
        //-------------------------------------------
        }));
        return function(axiosError) {
            return _ref.apply(this, arguments);
        };
    }());
    return apiInstance;
}
/* harmony default export */ var config_requestExodus = (requestExodus);


/***/ }),

/***/ 37213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ STOCKBIT_ACADEMY_URL; },
/* harmony export */   "CT": function() { return /* binding */ API_BASE_URL; },
/* harmony export */   "Cb": function() { return /* binding */ API_TRADING_URL; },
/* harmony export */   "GV": function() { return /* binding */ CUSTOM_USER_AGENT; },
/* harmony export */   "J3": function() { return /* binding */ GIPHY_STICKERS_URL; },
/* harmony export */   "Me": function() { return /* binding */ AWS_IMAGES_BUCKET; },
/* harmony export */   "UY": function() { return /* binding */ GIPHY_API_KEY; },
/* harmony export */   "VE": function() { return /* binding */ GOOGLE_PLAY_URL; },
/* harmony export */   "ZB": function() { return /* binding */ API_CURATOR_URL; },
/* harmony export */   "_O": function() { return /* binding */ SITE_URL; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "cu": function() { return /* binding */ API_TRADING_URL_V2; },
/* harmony export */   "fN": function() { return /* binding */ GIPHY_URL; },
/* harmony export */   "jd": function() { return /* binding */ CURATOR_FEED_ID; },
/* harmony export */   "kg": function() { return /* binding */ API_SECURITIES_GENERAL_URL; },
/* harmony export */   "l5": function() { return /* binding */ APP_STORE_URL; },
/* harmony export */   "lZ": function() { return /* binding */ FACEBOOK_APP_ID; },
/* harmony export */   "q$": function() { return /* binding */ AVATAR_URL; },
/* harmony export */   "q7": function() { return /* binding */ API_EXODUS_URL; },
/* harmony export */   "rM": function() { return /* binding */ AWS_EBOOK_BUCKET; },
/* harmony export */   "uJ": function() { return /* binding */ GOPAY_URL_JAVASCRIPT; },
/* harmony export */   "vw": function() { return /* binding */ AWS_TRADE_REG_BUCKET; }
/* harmony export */ });
/* unused harmony exports STAGE, API_SECURITIES_ALT_URL, SOCKET_URL, AWS_CHAT_BUCKET, GOPAY_QR_CODE_URL, GOPAY_REF_ID_URL, API_VERSION_ALT, DESKTOP_APP_BUCKET, DESKTOP_APP_SECRET_KEY, DESKTOP_APP_ACCESS_KEY, DESKTOP_APP_URL, DESKTOP_APP_END_POINT, CURATOR_TOKEN, APPLE_APP_SITE_ID */
/* provided dependency */ var process = __webpack_require__(34155);
var STAGE = (/* unused pure expression or super */ null && ("production" || 0));
var SITE_URL = "https://stockbit.com" || 0;
var SOCKET_URL = (/* unused pure expression or super */ null && ("https://ws3.stockbit.com/"));
// Separate the version with base URL, if we need more version
// just add from `.env`, then add them into this file
var API_VERSION = "v2.5";
var API_VERSION_ALT = "v2.4" || 0;
var API_BASE_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION);
var API_EXODUS_URL = "https://exodus.stockbit.com";
var API_TRADING_URL = "https://trading.masonline.id";
var API_TRADING_URL_V2 = "https://carina.stockbit.com";
var API_SECURITIES_ALT_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION_ALT);
// Can be used with social or trading authorization
var API_SECURITIES_GENERAL_URL = "https://api-sekuritas.stockbit.com";
var API_CURATOR_URL = "https://api.curator.io";
var AVATAR_URL = "https://avatar.stockbit.com" || 0;
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var AWS_IMAGES_BUCKET = "https://stockbit.s3.amazonaws.com";
var AWS_TRADE_REG_BUCKET = "https://simasreg.s3.amazonaws.com";
var AWS_EBOOK_BUCKET = "https://s3-ap-southeast-1.amazonaws.com/ebookstbx";
var AWS_CHAT_BUCKET = process.env.NEXT_PUBLIC_AWS_CHAT_BUCKET;
var GIPHY_URL = "https://api.giphy.com/v1/gifs";
var GIPHY_STICKERS_URL = "https://api.giphy.com/v1/stickers";
var GIPHY_API_KEY = "ZME7nTxOPIqXCf9qhCfqB1ICqtFCbCs5" || 0;
var GOPAY_URL_JAVASCRIPT = "https://app.midtrans.com/snap/snap.js" || 0;
var GOPAY_QR_CODE_URL = (/* unused pure expression or super */ null && ("https://api.sandbox.veritrans.co.id/v2/gopay/" || 0));
var GOPAY_REF_ID_URL = (/* unused pure expression or super */ null && ("https://simulator.sandbox.midtrans.com/gopay/ui/checkout?referenceid=" || 0));
var FACEBOOK_APP_ID = "247631672013136" || 0;
// link to download stockbit app
var GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.stockbit.android&hl=en";
var APP_STORE_URL = "https://itunes.apple.com/us/app/stockbit/id1184800207?mt=8";
var STOCKBIT_ACADEMY_URL = "https://academy.stockbit.com";
var CUSTOM_USER_AGENT = "webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d";
var DESKTOP_APP_BUCKET = (/* unused pure expression or super */ null && ("sb-sda-release"));
var DESKTOP_APP_SECRET_KEY = (/* unused pure expression or super */ null && ("EFKHBWQHWq0jWNNGM2/e35vU4vOrN4OHyd4f09Kv"));
var DESKTOP_APP_ACCESS_KEY = (/* unused pure expression or super */ null && ("AKIAX4CD7C6D4DF5LTF6"));
var DESKTOP_APP_URL = (/* unused pure expression or super */ null && ("https://sda-release.stockbit.com/"));
var DESKTOP_APP_END_POINT = (/* unused pure expression or super */ null && ("https://s3.ap-southeast-3.amazonaws.com/"));
var CURATOR_TOKEN = (/* unused pure expression or super */ null && ("ae406fc1-d23a-4a34-a0c9-164c7d2204ea"));
var CURATOR_FEED_ID = "1e81f0c0-550d-492e-b3ae-0dd4706df21f";
var APPLE_APP_SITE_ID = (/* unused pure expression or super */ null && ("ASHUNREKRL.stockbit.com.stockbit"));



/***/ }),

/***/ 86123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ GTM_ID; },
/* harmony export */   "C5": function() { return /* binding */ isClient; },
/* harmony export */   "Vc": function() { return /* binding */ assetPrefix; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "d7": function() { return /* binding */ CLEVERTAP_ID; },
/* harmony export */   "m6": function() { return /* binding */ TRADING_VIEW_ASSET_PREFIX; },
/* harmony export */   "mM": function() { return /* binding */ assetsStatic; },
/* harmony export */   "or": function() { return /* binding */ STAGE; },
/* harmony export */   "qV": function() { return /* binding */ PROJECT_FOLDER_PATH; },
/* harmony export */   "sP": function() { return /* binding */ PROJECT_FOLDER; },
/* harmony export */   "t0": function() { return /* binding */ CRISP_ID; },
/* harmony export */   "yv": function() { return /* binding */ isProduction; },
/* harmony export */   "yz": function() { return /* binding */ siteUrl; }
/* harmony export */ });
/* unused harmony exports CDN, R2_ASSET_PREFIX, FB_APP_ID, USER_AGENT, OPEN_HOUR, CLOSE_HOUR, isMarketOpen, STRUCTURED_DATA */
/* provided dependency */ var process = __webpack_require__(34155);
var PROJECT_FOLDER = process.env.NEXT_PUBLIC_PROJECT_FOLDER;
var PROJECT_FOLDER_PATH = PROJECT_FOLDER ? "/".concat(PROJECT_FOLDER) : "";
var CDN = "https://stockbit.com" || 0;
var assetPrefix = CDN ? "".concat(CDN).concat(PROJECT_FOLDER_PATH) : "";
var R2_ASSET_PREFIX = "https://web-assets.stockbit.com";
var TRADING_VIEW_ASSET_PREFIX = process.env.NEXT_PUBLIC_TV_ASSET || "https://stockbit.com/tradingview/charting_library/";
var FB_APP_ID = (/* unused pure expression or super */ null && ("247631672013136" || 0));
var GTM_ID = "GTM-5DQC6T3" || 0;
var siteUrl = "https://stockbit.com" || 0;
var STAGE = "production" || 0;
var CLEVERTAP_ID = "6ZW-897-5R6Z";
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var USER_AGENT = (/* unused pure expression or super */ null && ("webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d" || 0));
var CRISP_ID = "44ed90bf-ce78-4f5f-a9f8-82e000538b9b" || 0;
var isClient = function() {
    return "object" !== "undefined";
};
var isProduction = "production" === "production";
// Market hour
var OPEN_HOUR = 9;
var CLOSE_HOUR = 15;
var isMarketOpen = function() {
    var currentTime = new Date().getHours();
    // return currentTime >= OPEN_HOUR && currentTime <= CLOSE_HOUR;
    return currentTime >= OPEN_HOUR;
};
var STRUCTURED_DATA = {
    "@context": "http://schema.org",
    "@type": "Corporation",
    name: "Stockbit",
    legalName: "Stockbit",
    description: "Stockbit adalah komunitas investasi di Indonesia. Stockbit memberi ruang bagi investor dan trader untuk berbagi ide, berita dan informasi keuangan lainya secara real-time. Pengguna bisa membuat profil dan mengikuti saham tertentu atau investor favorit untuk mendapatkan informasi berharga dan bertukar pikiran. Fitur utama dari Stockbit yaitu 'stream' terdiri dari ide-ide, grafik saham, link dan data keuangan lainya. Stockbit menggunakan tanda '$' sebelum kode saham sebagai penandaan ide untuk mempermudah pengguna dalam mencari informasi tentang saham individu tertentu. Platform Stockbit juga terintegrasi dengan platform social media lainya, seperti Twitter dan Facebook, sehingga mudah untuk berbagi ide-ide di Stockbit ke akun Twitter dan Facebook pengguna. Stockbit dirancang dengan fitur yang terfokus dengan keperilakuan investor dan trader sehingga akan lebih berguna sebagai social media khusus investasi.",
    logo: "https://assets-nextjs.stockbit.com/img/favicon.ico",
    url: "https://stockbit.com",
    telephone: "+6221 57906242",
    sameAs: [
        "https://twitter.com/Stockbit",
        "https://www.linkedin.com/company/stockbit",
        "https://www.facebook.com/Stockbit",
        "https://www.youtube.com/c/Stockbit",
        "https://instagram.com/stockbit",
        "https://www.crunchbase.com/organization/stockbit", 
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta",
        addressLocality: "Jakarta Selatan",
        postalCode: "12930",
        addressCountry: "Indonesia"
    }
};
var assetsStatic = "".concat("https://assets.stockbit.com");


/***/ }),

/***/ 61608:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var ERROR_MESSAGE = {
    ALERT_RED: "alert-red",
    DEFAULT: "DEFAULT",
    MAINTENANCE: "MAINTENANCE",
    NOPERMISSION: "NOPERMISSION",
    NOTRADINGPERMISSION: "NOTRADINGPERMISSION",
    INVALIDPARAMETER: "INVALIDPARAMETER",
    INVALID_PARAMETER: "INVALID_PARAMETER",
    INVALID_RECAPTCHA: "INVALID_RECAPTCHA",
    INVALID_LOGIN: "INVALID_LOGIN",
    ERR_SYSTEM: "ERR_SYSTEM",
    ERR_INVALID_PARAMS: "ERR_INVALID_PARAMS",
    ERR_ORDER_FAIL: "ERR_ORDER_FAIL",
    ERR_PIN_INVALID: "ERR_PIN_INVALID",
    ERR_LOGIN_FAIL: "ERR_LOGIN_FAIL",
    INVALID_AMEND: "INVALID_AMEND",
    INVALID_PIN: "INVALID_PIN",
    SYSTEMERROR: "SYSTEMERROR",
    NOTFOUND: "NOTFOUND",
    NOSUBSCRIPTION: "NOSUBSCRIPTION",
    PAYWALL_ERROR: "PAYWALL",
    PAYWALL_NOSUBSCRIPTION: "NO_SUBSCRIPTION",
    NOPHONEVERIFY: "NOPHONEVERIFY",
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    SERVICE_BUSY: "SERVICE_BUSY",
    INVALID_SESSION: "INVALID_SESSION",
    ERR_LOGIN_AUTHORIZATION: "ERR_LOGIN_AUTHORIZATION",
    ERR_PIN_AUTHORIZATION: "ERR_PIN_AUTHORIZATION",
    ERR_UNKNOWN_BROKER: "ERR_UNKNOWN_BROKER",
    INCORRECT_PIN: "INCORRECT_PIN",
    INVALID_CREDS: "INVALID_CREDS",
    UNKNOWN_SYSTEM_ERROR: "Kondisi Internet Kamu Sedang Tidak Stabil.",
    OFFLINE: "Kondisi internet kamu sedang tidak stabil",
    DEFAULT_ERROR_MESSAGE: "Something is terribly wrong, please contact our administrator",
    PERMISSION_DENIED: "You do not have enough permission to access the resources",
    // error message upload avatar onboarding
    UPLOAD_FAILED: "Upload Failed",
    PLEASE_LOAD_IMAGE: "Please load an image",
    UPLOAD_IMAGE_TYPE_NOT_SUPPORTED: "Only image file (type: JPEG, JPG, PNG, and GIF) allowed",
    UPLOAD_DOCUMENT_TYPE_NOT_SUPPORTED: "Only document file (type: PDF, DOC, DOCX, PPT, PPTX, XLS and XLSX) allowed",
    MAX_FILE_SIZE: "Max File Size 2Mb",
    INVALID_AVATAR_EXTENSION: "Only image file (type: JPEG, JPG, and PNG) allowed",
    // stream error message
    DOCUMENT_IMAGE_NOT_ALLOWED: 'Image files (such as jpg, jpeg, png, gif) are not allowed to be uploaded from "Attach Document" input',
    MAX_UPLOAD_FILES: "Maximum of 1 file uploads allowed",
    STREAM_TEXT_REQUIRED: "Text is required in posts",
    STREAM_TARGET_PRICE_REQUIRED: "Target Price is required in posts",
    STREAM_ERROR_UPLOAD_FILE: "Upload file error",
    ACADEMY_ERROR_MESSAGE: "Failed to open Academy, Please reload this page",
    // Screener
    SCREENER_SPECIFY_RULES: "Please enter at least one screening rule",
    SCREENER_SPECIFY_RULES_VALUE: "Please enter a value on your screening rule",
    // Tipping
    TIPPING_MAX_AMOUNT_ERROR: "Jumlah Maksimal Tip Rp 10,000,000",
    // Fundachart
    MAX_METRICES_AND_SYMBOLS: "Harap pilih tidak lebih dari total 10 parameter (perusahaan/metrik) untuk bagan",
    // Chartbit
    LOAD_TEMPLATE: "Failed to load template",
    SAVE_TEMPLATE: "Failed to save template"
};
/* harmony default export */ __webpack_exports__["Z"] = (ERROR_MESSAGE);


/***/ }),

/***/ 44252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": function() { return /* binding */ REGISTRATION_DATA; },
/* harmony export */   "Nv": function() { return /* binding */ REFRESH_TOKEN_KEY_EXP; },
/* harmony export */   "Wx": function() { return /* binding */ ACCESS_TOKEN_KEY; },
/* harmony export */   "ns": function() { return /* binding */ ACCESS_USER_KEY; },
/* harmony export */   "w4": function() { return /* binding */ REFRESH_TOKEN_KEY; },
/* harmony export */   "z0": function() { return /* binding */ ACCESS_TOKEN_KEY_EXP; }
/* harmony export */ });
var ACCESS_TOKEN_KEY = "at";
var ACCESS_TOKEN_KEY_EXP = "ate";
var REFRESH_TOKEN_KEY = "ar";
var REFRESH_TOKEN_KEY_EXP = "are";
var ACCESS_USER_KEY = "au";
var REGISTRATION_DATA = "registerData";


/***/ }),

/***/ 41208:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var SUCCESS_MESSAGE = {
    ALERT_GREEN: "alert-green",
    SNACKBAR_GREEN: "snackbar-green",
    PROFILE_UPDATED: "Profile Updated",
    POST_SUCCESSFUL: "Post successful",
    REPOST_SUCCESSFUL: "Post Reposted",
    REPLY_SUCCESSFUL: "Post reply successful!",
    SET_TOP_SUCCESSFUL: "Set as Top successful!",
    REMOVE_TOP_SUCCESSFUL: "Remove as Top successful!",
    RESET_TOP_SUCCESSFUL: "Reset as Top successful!",
    UNTAG_POST_SUCCESSFUL: "Untag Post Topic Success",
    PASSWORD_CHANGED: "Password changed",
    USER_BLOCKED: "User blocked",
    USER_UNBLOCKED: "User unblocked",
    CHANGE_NUMBER_SUCCESSFUL: "Phone number changed!",
    SAVE_TEMPLATE_SUCCESS: "Success save template",
    POST_SHARED_SUCCESSFUL: "Post Shared",
    EVENT_SHARED_SUCCESSFUL: "Event Shared",
    POST_PINNED_SUCCESSFUL: "Post successfully pinned",
    POST_UNPINNED_SUCCESSFUL: "Post successfully unpinned",
    POST_SUCCESSFUL_UPDATE: "Post successfully updated",
    POST_SUCCESSFUL_DELETED: "Successfully deleted",
    SCREENER_TEMPLATE_DELETED: "Screener Template Deleted",
    FACEBOOK_CONNECTED: "Facebook connect successful",
    GOPAY_CHANGED: "Nomor gopay anda berhasil diubah",
    REPORT_DELIVERED: "Report has been delivered",
    UPDATE_GROUP_PHOTO_SUCCESSFUL: "Group Photo Updated",
    DELETE_STREAM_MULTIPLE_SUCCESSFUL: "Success delete stream",
    FINANCIAL_COLUMN_DELETED: "Financial Column Deleted"
};
/* harmony default export */ __webpack_exports__["Z"] = (SUCCESS_MESSAGE);


/***/ }),

/***/ 84116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(579);
/* harmony import */ var global_Icons_CloseSvg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79928);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82127);







var ModalNavigateConfirmation = function(param) {
    var _visible = param.visible, visible = _visible === void 0 ? false : _visible, _onLeave = param.onLeave, onLeave = _onLeave === void 0 ? function() {} : _onLeave, _onStay = param.onStay, onStay = _onStay === void 0 ? function() {} : _onStay;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .ModalConfirmation */ .o7, {
        visible: visible,
        centered: true,
        width: "400px",
        closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Icons_CloseSvg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            width: "10px",
            height: "10px"
        }),
        onCancel: onStay,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                align: "center",
                direction: "column",
                py: "30px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        src: "/icon/password-navigation.svg",
                        alt: "lock",
                        style: {
                            marginBottom: "18px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        weight: "700",
                        size: "16px",
                        height: "26px",
                        children: "Are You Sure Want to Leave This Page?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        weight: "400",
                        size: "14px",
                        height: "22px",
                        children: "If you leave now, you`'`ll have to start over."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        block: true,
                        height: "40px",
                        radius: "4px",
                        mr: "5px",
                        onClick: onStay,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            children: "Stay Here"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        // @ts-expect-error
                        ml: "5px",
                        type: "borderless",
                        block: true,
                        height: "40px",
                        radius: "4px",
                        style: {
                            backgroundColor: "#D74342",
                            color: "#FFFFFF"
                        },
                        onClick: onLeave,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            children: "Leave"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalNavigateConfirmation);


/***/ }),

/***/ 4365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82127);






var ModalSuccess = function(param) {
    var _visible = param.visible, visible = _visible === void 0 ? false : _visible, _onLogout = param.onLogout, onLogout = _onLogout === void 0 ? function() {} : _onLogout;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .ModalConfirmation */ .o7, {
        visible: visible,
        centered: true,
        width: "400px",
        closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
        onCancel: onLogout,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                align: "center",
                direction: "column",
                py: "30px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        src: "/icon/password-lock.svg",
                        alt: "lock",
                        style: {
                            marginBottom: "18px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        weight: "700",
                        size: "16px",
                        height: "26px",
                        children: "Your Password Has Been Changed"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        weight: "400",
                        size: "14px",
                        height: "22px",
                        children: "Please login again using new password."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                type: "primary",
                width: "160px",
                height: "40px",
                radius: "4px",
                onClick: onLogout,
                // @ts-expect-error
                mx: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                    children: "Back to Login"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalSuccess);


/***/ }),

/***/ 686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ LinkedDeviceBanner; },
/* harmony export */   "B5": function() { return /* binding */ NavigationHeader; },
/* harmony export */   "BP": function() { return /* binding */ LeftNavigation; },
/* harmony export */   "EU": function() { return /* binding */ RadioButton; },
/* harmony export */   "G_": function() { return /* binding */ PasswordSubmitButton; },
/* harmony export */   "IH": function() { return /* binding */ ProfileSwitch; },
/* harmony export */   "KX": function() { return /* binding */ LinkedDeviceButtonWrapper; },
/* harmony export */   "Ky": function() { return /* binding */ ProfileLabel; },
/* harmony export */   "Ol": function() { return /* binding */ CardHeader; },
/* harmony export */   "Tc": function() { return /* binding */ CustomConfigNavigation; },
/* harmony export */   "U1": function() { return /* binding */ ProfileInputGroup; },
/* harmony export */   "W2": function() { return /* binding */ LinkedDeviceModal; },
/* harmony export */   "WG": function() { return /* binding */ RegionFlag; },
/* harmony export */   "WX": function() { return /* binding */ CardHeaderTextContainer; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "aO": function() { return /* binding */ CardHeaderExtra; },
/* harmony export */   "aj": function() { return /* binding */ NotificationWrapper; },
/* harmony export */   "c": function() { return /* binding */ LinkedDeviceInformation; },
/* harmony export */   "eX": function() { return /* binding */ SectionLabel; },
/* harmony export */   "hS": function() { return /* binding */ EditProfileContainer; },
/* harmony export */   "ke": function() { return /* binding */ CheckboxLabel; },
/* harmony export */   "kr": function() { return /* binding */ CustomNavigationItem; },
/* harmony export */   "m$": function() { return /* binding */ PasswordCancelButton; },
/* harmony export */   "pr": function() { return /* binding */ EditProfileCard; },
/* harmony export */   "t$": function() { return /* binding */ LinkedDeviceButton; },
/* harmony export */   "u_": function() { return /* binding */ Modal; },
/* harmony export */   "vD": function() { return /* binding */ LinkedDeviceItem; },
/* harmony export */   "wP": function() { return /* binding */ CardHeaderTitle; },
/* harmony export */   "wy": function() { return /* binding */ PrivacySectionTitle; }
/* harmony export */ });
/* unused harmony exports IconMoreWrapper, Frame, Avatar, NavigationItem, TogglePassword, InputPassword */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_common_Card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81301);
/* harmony import */ var _deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81190);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_profile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16484);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22147);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 30%;\n  margin-right: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 180px;\n  border: solid 1px ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 180px;\n  height: 180px;\n  background: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  background: ",
        ";\n  padding: 15px 29px;\n  border: 1px solid ",
        ";\n  border-bottom: none;\n  border-radius: 3px 3px 0 0!important;\n  width: 100%;\n\n  img {\n    display: block;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-left: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: 'center';\n  align-items: 'flex-end';\n  width: 30px;\n  height: 40px;\n  display: flex;\n  transform: rotate(90deg);\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border: 1px solid ",
        ";\n  border-bottom: 0 solid;\n  transition: background 0.3s;\n  background: ",
        ";\n  cursor: pointer;\n  position: relative;\n  height: ",
        ";\n\n  &:last-of-type {\n    border-radius: 0 0 3px 3px;\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 16px;\n  min-width: 150px;\n  color: ",
        ";\n  text-align: start;\n\n  @media ",
        " {\n    text-align: end;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  margin-bottom: 24px;\n  ",
        "\n\n  .ant-input-group-wrapper {\n    border: none !important;\n  }\n\n  @media ",
        " {\n    align-items: flex-start;\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  :checked + label {\n    border-radius: 4px;\n    border: 2px solid ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 40px;\n  display: block;\n  position: relative;\n  cursor: pointer;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 8px 2px;\n  font-size: 12px;\n  font-weight: 400;\n  color: ",
        ";\n  padding: 16px 0px 12px !important;\n  width: calc(100% - 16px) !important;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  width: 100%;\n  padding: 10px 8px;\n  border: none !important;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        background: ",
        ";\n      "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  width: 100%;\n  padding: 24px 20px;\n  border-right: 1px solid ",
        ";\n  align-items: center;\n\n  :hover {\n    border-right: 1px solid ",
        ";\n  }\n\n  &:last-of-type {\n    border-radius: 0 0 3px 3px !important;\n  }\n\n  :before {\n    content: '';\n    position: absolute;\n    right: 0;\n    width: 3px;\n    height: 100%;\n    background: transparent;\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  padding: 20px;\n  border: 1px solid ",
        ";\n  border-bottom: 0 solid;\n  background: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  width: 100%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-card-head {\n    border-color: ",
        ";\n  }\n\n  .ant-card-head-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin: 0 -5px;\n  }\n\n  .ant-card-head-title {\n    font-size: 16px;\n    color: ",
        ";\n    padding: 0;\n  }\n\n  .ant-card-extra {\n    font-size: 14px;\n    margin-left: 0px;\n    padding: 0px;\n  }\n\n  .ant-btn-primary[disabled] {\n    background: #8cd9bc !important;\n    color: #ffffff !important;\n  }\n\n  @media ",
        " {\n    .ant-card-head-wrapper {\n      display: flex;\n      flex-direction: row;\n      padding: 16px 5px;\n    }\n\n    .ant-card-head-title {\n      margin: 0;\n      padding: 0;\n    }\n\n    .ant-card-extra {\n      font-size: 16px;\n      margin: 0;\n      padding: 0;\n    }\n  }\n\n  @media ",
        " {\n    .ant-card-extra {\n      margin: 0;\n      padding: 0;\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-checkbox-inner {\n    border-radius: 100% !important;\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background: ",
        ";\n    border-color: ",
        "!important;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: -25px;\n  margin-top: 8px;\n  z-index: 99;\n  width: 15px;\n  cursor: pointer;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 95px;\n  height: 35px;\n  border-radius: 2px;\n  border: none;\n  font-family: var(--bold-font);\n  background: ",
        ";\n  color: ",
        ";\n  margin-left: 10px;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none !important;\n  min-width: 95px;\n  height: 35px;\n  font-family: var(--bold-font);\n  background: ",
        " !important;\n  color: ",
        " !important;\n  box-shadow: none;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid\n    ",
        " !important;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  width: calc(100% - 210px);\n\n  .ant-btn-primary[disabled] {\n    background: #8cd9bc !important;\n    color: #ffffff !important;\n\n    &:hover > p {\n      color: #ffffff;\n    }\n  }\n\n  button.ant-btn {\n    box-shadow: none;\n    margin-right: 10px;\n  }\n\n  & > div {\n    border-radius: 3px;\n  }\n\n  & > div:nth-child(2) {\n    border-radius: 0 0 3px 3px;\n  }\n\n  @media ",
        " {\n    width: 530px;\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border: none;\n        "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    padding: 0 20px !important;\n    height: 40px;\n    border-bottom: solid 1px ",
        ";\n\n    ",
        "\n  }\n  .ant-modal-body {\n    padding: 20px;\n  }\n  .ant-modal-footer {\n    padding: 0 !important;\n    text-align: left;\n    display: flex;\n\n    button {\n      border-radius: 3px;\n    }\n  }\n  .ant-modal-close-x {\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f7f7f7;\n  margin-bottom: 16px;\n\n  span {\n    margin-left: 10px;\n    font-size: 12px;\n    line-height: 16px;\n    color: #858585;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border-bottom: 1px solid #f1f1f1;\n  padding: 14px 0;\n\n  p {\n    margin-bottom: 2px;\n  }\n\n  .device-name {\n    font-size: 14px;\n    line-height: 18px;\n\n    span {\n      color: #00ab6b;\n    }\n\n    span::before {\n      content: ' • ';\n      color: #333333;\n    }\n  }\n\n  .device-login-information {\n    font-size: 12px;\n    line-height: 16px;\n    color: #858585;\n  }\n\n  .device-remove {\n    cursor: pointer;\n    font-size: 10px;\n    margin-left: auto;\n    padding-top: 22px;\n  }\n\n  .device-icon {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  color: #00ab6b;\n  font-size: 14px;\n  line-height: 18px;\n  padding-top: 16px;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 8px;\n  }\n\n  .ant-modal-header {\n    border-radius: 8px 8px 0 0;\n    border-bottom: none;\n    padding: 20px 20px 12px 20px !important;\n  }\n\n  .ant-modal-title {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 17px;\n  }\n\n  .ant-modal-body {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  padding: 10px 20px 20px;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border: 1px solid #00ab6b;\n          color: #ffffff;\n          background: #00ab6b;\n        "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border: 1px solid #ededed;\n          color: #333333;\n          background: #ffffff;\n        "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  min-width: 120px;\n  min-height: 40px;\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 700;\n  align: center;\n  border-radius: 4px;\n  margin: 0 10px;\n\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}












var LeftNavigation = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-0"
})(_templateObject());
var Frame = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    direction: "column",
    align: "center"
}).withConfig({
    componentId: "sc-93cbe1cb-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro);
var Avatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].mischka */ .Z.mischka);
var CardHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro);
var CardHeaderTextContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-4"
})(_templateObject4());
var CardHeaderTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    size: "16px"
}).withConfig({
    componentId: "sc-93cbe1cb-5"
})(_templateObject5());
var CardHeaderExtra = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    size: "14px",
    align: "right",
    color: "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary)
}).withConfig({
    componentId: "sc-93cbe1cb-6"
})(_templateObject6());
var IconMoreWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-7"
})(_templateObject7(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].tablet */ .Z.tablet);
var NavigationItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs(function(props) {
    return {
        isActive: props.isActive || false,
        height: props.height || "40px"
    };
}).withConfig({
    componentId: "sc-93cbe1cb-8"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light, function(param) {
    var height = param.height;
    return height;
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro);
var ProfileLabel = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].label.attrs */ .ZP.label.attrs({
    className: "control-label"
}).withConfig({
    componentId: "sc-93cbe1cb-9"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].highempahis */ .Z.highempahis, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].tablet */ .Z.tablet);
var ProfileInputGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs(function(props) {
    return {
        // @ts-expect-error
        isFluid: props.isFluid || false,
        // @ts-expect-error
        align: props.align || "center",
        className: "control-group"
    };
}).withConfig({
    componentId: "sc-93cbe1cb-10"
})(_templateObject11(), function(param) {
    var isFluid = param.isFluid;
    return isFluid && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject10());
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].tablet */ .Z.tablet);
var RadioButton = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-93cbe1cb-11"
})(_templateObject12(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
var RegionFlag = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-12"
})(_templateObject13());
var CheckboxLabel = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-93cbe1cb-13"
})(_templateObject14(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].highempahis */ .Z.highempahis);
var SectionLabel = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-93cbe1cb-14"
})(_templateObject15(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
var NotificationWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-15"
})(_templateObject16());
var ProfileSwitch = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_profile__WEBPACK_IMPORTED_MODULE_8__/* .ProfileSwitch */ .IH).withConfig({
    componentId: "sc-93cbe1cb-16"
})(_templateObject18(), function(param) {
    var checked = param.checked;
    return checked && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject17(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
});
var CustomNavigationItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_profile__WEBPACK_IMPORTED_MODULE_8__/* .ConfigNavigationItem */ .SS).withConfig({
    componentId: "sc-93cbe1cb-17"
})(_templateObject21(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject19(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject20(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].aliceBlue */ .Z.aliceBlue);
});
var NavigationHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-18"
})(_templateObject22(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light);
var CustomConfigNavigation = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_profile__WEBPACK_IMPORTED_MODULE_8__/* .ConfigNavigation */ .Vt).withConfig({
    componentId: "sc-93cbe1cb-19"
})(_templateObject23());
var EditProfileCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Card__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-20"
})(_templateObject24(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, function(props) {
    return(// @ts-expect-error
    props.isHideTitle ? "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light) : "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary));
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].laptop */ .Z.laptop);
var PrivacySectionTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    width: "100%",
    py: "20px"
}).withConfig({
    componentId: "sc-93cbe1cb-21"
})(_templateObject25(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].downgray */ .Z.downgray);
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-22"
})(_templateObject26(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
var TogglePassword = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-23"
})(_templateObject27());
var PasswordSubmitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-24"
})(_templateObject28(), function(props) {
    return props.disabled ? "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary, " !important") : "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
}, function(props) {
    return props.disabled ? "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light, " !important") : "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light);
});
var PasswordCancelButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-25"
})(_templateObject29(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].midgray */ .Z.midgray);
var InputPassword = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    autoComplete: "new-password"
}).withConfig({
    componentId: "sc-93cbe1cb-26"
})(_templateObject30(), function(props) {
    return(// @ts-expect-error
    props.error ? "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].sunsetOrange */ .Z.sunsetOrange) : "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro));
});
var EditProfileContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-27"
})(_templateObject31(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].laptop */ .Z.laptop);
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-93cbe1cb-28"
})(_templateObject33(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, // @ts-expect-error
function(param) {
    var noBorder = param.noBorder;
    return noBorder && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject32());
});
var LinkedDeviceBanner = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-93cbe1cb-29"
})(_templateObject34());
var LinkedDeviceItem = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-93cbe1cb-30"
})(_templateObject35());
var LinkedDeviceInformation = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-93cbe1cb-31"
})(_templateObject36());
var LinkedDeviceModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(Modal).withConfig({
    componentId: "sc-93cbe1cb-32"
})(_templateObject37());
var LinkedDeviceButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-93cbe1cb-33"
})(_templateObject38());
var LinkedDeviceButton = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-93cbe1cb-34"
})(_templateObject41(), function(props) {
    return props.primary ? (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject39()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject40());
});



/***/ }),

/***/ 51346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ku": function() { return /* binding */ localStorageOrderbookHandler; },
/* harmony export */   "M6": function() { return /* binding */ transformNewOrderbookListToExisting; },
/* harmony export */   "g8": function() { return /* binding */ memoizeChild; }
/* harmony export */ });
/* unused harmony export getErrorMessage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var localStorageOrderbookHandler = {
    get: function() {
        var orderbookName = localStorage.getItem("orderbooklistName");
        var orderbookID = localStorage.getItem("orderbooklistID");
        return {
            orderbookName: orderbookName,
            orderbookID: orderbookID
        };
    },
    set: function(orderbookName, orderbookID) {
        localStorage.setItem("orderbooklistID", orderbookID);
        localStorage.setItem("orderbooklistName", orderbookName);
    },
    remove: function() {
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
};
var getErrorMessage = function(error) {
    var ref;
    var err = _instanceof(error, Error) ? (error === null || error === void 0 ? void 0 : (ref = error.cause) === null || ref === void 0 ? void 0 : ref.message) || error.message : String(error);
    return err;
};
var memoizeChild = function(component) {
    var circular = function() {
        var seen = new WeakSet();
        return function(key, value) {
            if (key.startsWith("_")) return; // Don't compare React's internal props.
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return;
                seen.add(value);
            }
            // eslint-disable-next-line consistent-return
            return value;
        };
    };
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(component, function(prevProps, nextProps) {
        var prev = JSON.stringify(prevProps, circular());
        var next = JSON.stringify(nextProps, circular());
        return prev === next;
    });
};
var transformNewOrderbookListToExisting = function(newResponse) {
    var tradeable = newResponse.tradable ? 1 : 0;
    var bidObject = {};
    var offerObject = {};
    newResponse.bid.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        bidObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        bidObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        bidObject[valueNameKey] = value.volume;
    });
    newResponse.offer.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        offerObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        offerObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        offerObject[valueNameKey] = value.volume;
    });
    return {
        id: newResponse.id,
        symbol: newResponse.symbol,
        symbol_2: newResponse.symbol,
        symbol_3: newResponse.symbol,
        name: newResponse.name,
        status: newResponse.status,
        lastprice: newResponse.lastprice,
        previous: newResponse.previous,
        change: newResponse.change,
        percentage_change: newResponse.percentage_change,
        open: newResponse.open,
        high: newResponse.high,
        low: newResponse.low,
        close: newResponse.close,
        volume: newResponse.volume,
        value: newResponse.value,
        average: newResponse.average,
        bid: bidObject,
        offer: offerObject,
        frequency: newResponse.frequency,
        fbuy: newResponse.fbuy,
        fsell: newResponse.fsell,
        fnet: newResponse.fnet,
        fpercent: newResponse.fpercent,
        tradeable: tradeable,
        notation: newResponse.notation,
        uma: newResponse.uma,
        GUID: null,
        is_foreignbs_exist: newResponse.has_foreign_bs,
        exchange: newResponse.exchange,
        country: null,
        foreign: null,
        domestic: null,
        up: null,
        down: null,
        unchanged: null,
        iepiev: newResponse.iepiev,
        ara: newResponse.ara,
        arb: newResponse.arb,
        company_type: newResponse.company_type,
        corp_action: newResponse.corp_action,
        market_data: newResponse.market_data,
        auto_reject_estimation: newResponse.auto_reject_estimation
    };
};


/***/ }),

/***/ 25516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AlertErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 50%;\n  margin-right: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* IconWrapper */.a).withConfig({
    componentId: "sc-1624a33f-0"
})(_templateObject(), color/* default.primary */.Z.primary);
// eslint-disable-next-line import/prefer-default-export


;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/index.js
/* eslint-disable max-len */ 







/**
 * handleErrorMessageAPI to activate message
 * @param {string} content
 * @param {string} type - "alert-green" | "alert-red" | "alert-orange" | "alert-blue" | "snackbar-green" | "plain-green"
 * @param {=boolean} hasCloseIcon
 */ var handleErrorMessageAPI = function(content, type) {
    var hasCloseIcon = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0,app/* isClient */.C5)()) return null;
    // destroy last message alert
    message/* default.destroy */.ZP.destroy();
    var Icon = null;
    var closeIcon = hasCloseIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/icon/alert-close.svg",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    }) : null;
    if (type === "alert-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                size: "14px",
                className: "icon-toolbar_check",
                color: color/* default.light */.Z.light
            })
        });
    } else if (type === "snackbar-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/alert-success.svg"
        });
    }
    // show alert
    message/* default.open */.ZP.open({
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: type,
            "data-cy": "global-alert-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    Icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: content
                    }),
                    closeIcon
                ]
            })
        }),
        duration: 3,
        style: {
            top: "50px",
            fontFamily: "ProximaNovaRg",
            left: 0,
            margin: "auto",
            position: "fixed",
            right: 0,
            maxWidth: "320px"
        },
        className: "sysmsg-content",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    });
    return null;
};
/* harmony default export */ var AlertErrorMessage = (handleErrorMessageAPI);


/***/ }),

/***/ 6430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12461);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25935);





var alertIcon = {
    success: "alert-success.svg",
    warning: "alert-warning.svg",
    info: "alert-info.svg",
    error: "alert-error.svg"
};
function alertMessage(param) {
    var content = param.content, messageType = param.messageType, alertType = param.alertType, _hasCloseIcon = param.hasCloseIcon, hasCloseIcon = _hasCloseIcon === void 0 ? false : _hasCloseIcon, _duration = param.duration, duration = _duration === void 0 ? 3 : _duration, _onCloseHandler = param.onCloseHandler, onCloseHandler = _onCloseHandler === void 0 ? function() {} : _onCloseHandler;
    antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
    var Icon = null;
    if (alertType === "snackbar" || alertType === "snackbar-dark") {
        Icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: "/icon/".concat(alertIcon[messageType])
        });
    }
    var closeIcon = hasCloseIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "notif-close-icon",
        src: "/icon/alert-close.svg",
        onClick: function() {
            return antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
        }
    }) : null;
    antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].open */ .ZP.open({
        type: messageType,
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "message-".concat(messageType, " alert-").concat(alertType),
            "data-cy": "global-alert-message",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "center",
                children: [
                    Icon,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(content)
                    }),
                    closeIcon
                ]
            })
        }),
        duration: duration,
        style: {
            top: "50px",
            fontFamily: "ProximaNovaRg",
            left: 0,
            margin: "auto",
            position: "fixed",
            right: 0
        },
        icon: null,
        className: "sysmsg-alert",
        onClick: function() {
            return antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
        },
        onClose: onCloseHandler
    });
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (alertMessage);


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 73580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: null,
    errorMessage: "",
    errorType: ""
};
var mainLayoutStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (mainLayoutStore);


/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 13114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ AcceptanceLanguageEnum; },
/* harmony export */   "RD": function() { return /* binding */ SubAccountType; },
/* harmony export */   "el": function() { return /* binding */ TnCFeaturesIDEnum; },
/* harmony export */   "go": function() { return /* binding */ SubAccountStatus; },
/* harmony export */   "hO": function() { return /* binding */ TnCFeatureIDEnum; },
/* harmony export */   "rO": function() { return /* binding */ TnCFeaturePersistMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var AcceptanceLanguageEnum;
(function(AcceptanceLanguageEnum) {
    AcceptanceLanguageEnum["BAHASA"] = "ID";
    AcceptanceLanguageEnum["ENGLISH"] = "EN";
})(AcceptanceLanguageEnum || (AcceptanceLanguageEnum = {}));
var TnCFeatureIDEnum;
(function(TnCFeatureIDEnum) {
    TnCFeatureIDEnum[TnCFeatureIDEnum["FEATURE_UNSPECIFIED"] = 0] = "FEATURE_UNSPECIFIED";
    TnCFeatureIDEnum[TnCFeatureIDEnum["FEATURE_TRADING_LIMIT"] = 1] = "FEATURE_TRADING_LIMIT";
})(TnCFeatureIDEnum || (TnCFeatureIDEnum = {}));
var SubAccountType;
(function(SubAccountType) {
    SubAccountType["DAY_TRADE"] = "SUB_ACCOUNT_TYPE_DAY_TRADE";
})(SubAccountType || (SubAccountType = {}));
var SubAccountStatus;
(function(SubAccountStatus) {
    SubAccountStatus["ACTIVE"] = "SUB_ACCOUNT_STATUS_ACTIVE";
})(SubAccountStatus || (SubAccountStatus = {}));
var TnCFeaturesIDEnum;
(function(TnCFeaturesIDEnum) {
    TnCFeaturesIDEnum["TRADING_LIMIT"] = "FEATURE_ID_TRADING_LIMIT";
    TnCFeaturesIDEnum["AUTO_ORDER"] = "FEATURE_ID_AUTO_ORDER";
    TnCFeaturesIDEnum["DAY_TRADE"] = "FEATURE_ID_DAY_TRADE";
    TnCFeaturesIDEnum["MULTI_PORTO"] = "FEATURE_ID_MULTIPLE_PORTFOLIO";
})(TnCFeaturesIDEnum || (TnCFeaturesIDEnum = {}));
var _obj;
var TnCFeaturePersistMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.TRADING_LIMIT, "tradingLimitTnc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.AUTO_ORDER, "autoOrderTnc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.DAY_TRADE, "dayTradeTnc"), _obj);


/***/ }),

/***/ 78372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13114);


var exodusInstance = {
    defaultInstance: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
    noAlert: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false),
    withLanguageInstance: function() {
        var language = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA, disableErrorAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(disableErrorAlert, undefined, false, {
            "Accept-Language": language
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (exodusInstance);


/***/ }),

/***/ 1955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/** @typedef {import('axios').AxiosResponse} AxiosResponse */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 



var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestExodusNoAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
// Configs
var USER_URL = "/user";
var USER_PROFILE_URL = "".concat(USER_URL, "/profile");
var USER_EXODUS_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/user");
// onboarding
var USER_ONBOARDING = "".concat(USER_URL, "/onboarding");
var USER_CONNECT_SOCIAL_MEDIA = "".concat(USER_URL, "/v2/connect");
var USER_DISCONNECT_SOCIAL_MEDIA = "".concat(USER_URL, "/disconnect");
// avatar
var USER_AVATAR3D_LIST_URL = "".concat(USER_URL, "/avatar/collection");
// Block
/**
 * Block user by User id.
 * @param {string} userId - string of user id
 * @returns {APIResponse}
 */ var blockUser = function(userId) {
    return requestExodus.post("".concat(USER_EXODUS_URL, "/").concat(userId, "/block"));
};
/**
 * Block user by User id.
 * @param {string} userId - string of user id
 * @returns {APIResponse}
 */ var unblockUser = function(userId) {
    return requestExodus.post("".concat(USER_EXODUS_URL, "/").concat(userId, "/unblock"));
};
/**
 * Get list of blocked users
 * @param {number} page - target page
 * @returns {APIResponse}
 */ var getBlockedUser = function() {
    var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return requestExodusNoAlert.get("".concat(USER_EXODUS_URL, "/blocked"), {
        params: {
            page: page
        }
    });
};
// User Profile
/**
 * Edit user profile.
 * @param {string} userId - string of user id
 * @param {string} website - string of website url
 * @param {string} gender - string of user gender
 * @param {string} about - string of user descriptions
 * @param {string} avatar - string of avatar url
 * @param {string} fullname - string of user's fullname
 * @param {string} email  - string of user's email
 * @param {string} exchange - string of user's exchange
 */ var editUserProfile = function(_param) {
    var website = _param.website, gender = _param.gender, about = _param.about, avatar = _param.avatar, fullname = _param.fullname, email = _param.email, exchange = _param.exchange, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "website",
        "gender",
        "about",
        "avatar",
        "fullname",
        "email",
        "exchange"
    ]);
    return requestExodusNoAlert.put("".concat(USER_EXODUS_URL, "/profile"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        website: website,
        gender: gender,
        about: about,
        avatar: avatar,
        fullname: fullname,
        email: email,
        exchange: exchange
    }, params));
};
/**
 * Get list of trending user by range of time
 * @param {string} timeRange - range of time indicator ['1W']
 * @returns {APIResponse}
 */ var getTrendingUser = function() {
    var timeRange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1W";
    return requestExodusNoAlert.get("".concat(USER_EXODUS_URL, "/trending"), {
        params: {
            key: timeRange
        }
    });
};
/**
 * Get user profile by username
 * @param {string} username - exact username of user
 * @return {AxiosResponse}
 */ var getUserProfile = function(username) {
    return requestExodusNoAlert.get("".concat(USER_PROFILE_URL, "/").concat(username));
};
/**
 * Get user profile graph by username
 * @param {string} username - exact username of user
 * @return {AxiosResponse}
 */ var getUserProfileGraph = function(username) {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/usergraph/socialinfo/").concat(username));
};
var getGuestUserProfileGraph = function(username) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/usergraph/non-login/socialinfo/").concat(username));
};
/**
 * Get current user profile graph
 * @return {AxiosResponse}
 */ var getCurrentUserProfileGraph = function() {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/usergraph/socialinfo/user/me"));
};
/**
 * Get user profile by username
 * @param {string} username - exact username of user
 * @return {AxiosResponse}
 */ var getUserProfileExodus = function(username) {
    return requestExodusNoAlert.get("".concat(USER_EXODUS_URL, "/profile/").concat(username));
};
/**
 * retrieveUploadToken
 * to skip onboarding process
 */ var retrieveUploadToken = function(fileName) {
    return requestExodus.post("".concat(USER_URL, "/upload/token"), {
        filename: fileName
    });
};
/**
 * userSkipOnboarding
 * to skip onboarding process
 * @param {number} step - next step onboarding
 */ var userSkipOnboarding = function(step) {
    return requestExodus.post("".concat(USER_ONBOARDING), {
        step: step
    });
};
/**
 * userConnectSocialMedia
 * to connect user to social media account
 * @param {string} socialMediaName - social media's name
 * @param {object} requestBody - spcial media's object needed
 */ var userConnectSocialMedia = function(socialMediaName, requestBody) {
    return requestExodus.post("".concat(USER_CONNECT_SOCIAL_MEDIA, "/").concat(socialMediaName), requestBody);
};
/**
 * Disconnect social media from user account
 * @param {string} socialMediaName
 * @return {APIResponse}
 */ var disconnectSocialMedia = function(socialMediaName, requestBody) {
    return requestExodus.post("".concat(USER_DISCONNECT_SOCIAL_MEDIA, "/").concat(socialMediaName), requestBody);
};
/**
 * Mute user
 * @param {Object} suspendData - The data sent when suspend user
 * @param {number} suspendData.userid - User ID
 * @param {number} suspendData.postid - User ID
 * @param {number} suspendData.blockmode - Type of suspension
 * @param {string} suspendData.reason - Mute reason
 * @param {string} suspendData.duration - Mute duration
 * @param {boolean} suspendData.sendEmail - Send notification of being mute to user
 * @param {boolean} suspendData.blockIp - Block IP permanently from system
 *
 * @return {AxiosResponse}
 */ var suspendUser = function(param) {
    var userid = param.userid, postid = param.postid, blockmode = param.blockmode, reason = param.reason, duration = param.duration, sendEmail = param.sendEmail, blockIp = param.blockIp;
    var data = {
        type: blockmode,
        user_id: userid,
        reason: reason,
        days: duration,
        stream_id: postid,
        send_email: sendEmail,
        block_ip: blockIp
    };
    return requestExodus.post("".concat(USER_URL, "/admin/suspend"), data);
};
/**
 * Get Avatar3D List
 * @returns {AxiosResponse}
 */ var getAvatar3DList = function() {
    return requestExodusNoAlert.get("".concat(USER_AVATAR3D_LIST_URL));
};
var updatePreference = function(data) {
    return requestExodus.put("".concat(USER_EXODUS_URL, "/profile/country"), data);
};
// Exports ---------------------------------------------------------------------
/* harmony default export */ __webpack_exports__["Z"] = ({
    blockUser: blockUser,
    unblockUser: unblockUser,
    getBlockedUser: getBlockedUser,
    editUserProfile: editUserProfile,
    getTrendingUser: getTrendingUser,
    getUserProfile: getUserProfile,
    getUserProfileExodus: getUserProfileExodus,
    getUserProfileGraph: getUserProfileGraph,
    getGuestUserProfileGraph: getGuestUserProfileGraph,
    getCurrentUserProfileGraph: getCurrentUserProfileGraph,
    retrieveUploadToken: retrieveUploadToken,
    userSkipOnboarding: userSkipOnboarding,
    userConnectSocialMedia: userConnectSocialMedia,
    disconnectSocialMedia: disconnectSocialMedia,
    suspendUser: suspendUser,
    getAvatar3DList: getAvatar3DList,
    updatePreference: updatePreference
});


/***/ }),

/***/ 79644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ VerifiedStatus; }
/* harmony export */ });
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/** @typedef {import('axios').AxiosResponse} AxiosResponse */ 
var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
// Configs
var VERIFIED_BADGE_URL = "/verified-badge";
var VERIFIED_BADGE_USER_URL = "".concat(VERIFIED_BADGE_URL, "/user");
/**
 * Get verified badge user
 * @param {Number} userId - userid
 * @return {AxiosResponse}
 */ var getVerifiedBadgeUser = function(userId) {
    return requestExodus.get("".concat(VERIFIED_BADGE_USER_URL, "/").concat(userId));
};
var VerifiedStatus;
(function(VerifiedStatus) {
    VerifiedStatus["VERIFIED_STATUS_UNVERIFIED"] = "VERIFIED_STATUS_UNVERIFIED";
    VerifiedStatus["VERIFIED_STATUS_IDENTITY"] = "VERIFIED_STATUS_IDENTITY";
    VerifiedStatus["VERIFIED_STATUS_COMMUNITY"] = "VERIFIED_STATUS_COMMUNITY";
})(VerifiedStatus || (VerifiedStatus = {}));
// Exports ---------------------------------------------------------------------

/* harmony default export */ __webpack_exports__["Z"] = ({
    getVerifiedBadgeUser: getVerifiedBadgeUser
});


/***/ }),

/***/ 333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ profile; },
  "Sz": function() { return /* binding */ effects; },
  "Cr": function() { return /* binding */ proExpirySelector; },
  "Rd": function() { return /* binding */ profileSelector; },
  "wl": function() { return /* binding */ selectors; }
});

// UNUSED EXPORTS: initialState, userIdSelector

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/lib/api/user.ts
var user = __webpack_require__(1955);
// EXTERNAL MODULE: ./src/lib/api/verifiedBadge.ts
var verifiedBadge = __webpack_require__(79644);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/user/index.js

var schema = {
    id: "",
    username: "",
    fullname: "",
    email: "",
    activated: "",
    banned: "0",
    user_banned_until: "",
    ban_reason: null,
    last_login: "",
    created: "",
    modified: "",
    avatar: "",
    about: "",
    location: "",
    website: "",
    occupation: "",
    gender: "",
    birthday: "",
    phone: "",
    address: "",
    hide_email: "0",
    user_attr: "",
    user_priv: "0",
    tutorial: "0",
    user_newsletter: "",
    country: "ID",
    exchange: "",
    facebook_id: null,
    apple_id: null,
    google_id: null,
    email_subscribe: "",
    user_phone_verification: "",
    facebook_hide: "",
    language: "",
    user_preferences: {},
    user_trading: "",
    user_badge_top: "",
    followed: 0,
    ispro: 0,
    pro_active_since: "",
    pro_expire_at: "",
    tradingpro: 0,
    official: 0,
    trending: 0,
    ir_symbol: "",
    isblocked: 0,
    alert: 0,
    onboarding: 0,
    onboarding_done: 0,
    discover: 0,
    ftcode: "",
    ftend: "",
    realtrading_access: 0,
    top_badge: 0,
    is_term_agreed: 0,
    onesignal_hash: "",
    password: 0,
    support: {
        id: ""
    }
};
var propTypes = {
    id: prop_types.string,
    username: prop_types.string,
    fullname: prop_types.string,
    email: prop_types.string,
    activated: prop_types.string,
    banned: prop_types.string,
    user_banned_until: prop_types.string,
    ban_reason: prop_types.string,
    last_login: prop_types.string,
    created: prop_types.string,
    modified: prop_types.string,
    avatar: prop_types.string,
    about: prop_types.string,
    location: prop_types.string,
    website: prop_types.string,
    occupation: prop_types.string,
    gender: prop_types.string,
    birthday: prop_types.string,
    phone: prop_types.string,
    address: prop_types.string,
    user_attr: prop_types.string,
    user_newsletter: prop_types.string,
    country: prop_types.string,
    exchange: prop_types.string,
    hide_email: prop_types.string,
    user_priv: prop_types.string,
    tutorial: prop_types.string,
    facebook_id: prop_types.string,
    apple_id: prop_types.string,
    google_id: prop_types.string,
    email_subscribe: prop_types.string,
    user_phone_verification: prop_types.string,
    facebook_hide: prop_types.string,
    language: prop_types.string,
    user_preferences: (0,prop_types.oneOfType)([
        prop_types.object,
        prop_types.any
    ]),
    user_trading: prop_types.string,
    user_badge_top: prop_types.string,
    followed: prop_types.number,
    ispro: prop_types.number,
    pro_active_since: prop_types.string,
    pro_expire_at: prop_types.string,
    tradingpro: prop_types.number,
    official: prop_types.number,
    trending: prop_types.number,
    ir_symbol: prop_types.string,
    isblocked: prop_types.number,
    alert: prop_types.number,
    onboarding: prop_types.number,
    onboarding_done: prop_types.number,
    discover: prop_types.number,
    ftcode: prop_types.string,
    ftend: prop_types.string,
    onesignal_hash: prop_types.string,
    realtrading_access: prop_types.number,
    top_badge: prop_types.number,
    is_term_agreed: prop_types.number,
    password: prop_types.number
};
/* harmony default export */ var models_user = ({
    schema: schema,
    propTypes: propTypes
});

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/utils/userResponseMapping.ts



var formatDate = function(date) {
    return moment_default()(date).format("YYYY-MM-DD HH:mm:ss");
};
var userResponseMapping = function(data) {
    var id = data.id, created_at = data.created_at, statistics = data.statistics, profile = data.profile, privilege = data.privilege, exchange = data.exchange, ir_symbols = data.ir_symbols, badges = data.badges, is_alert_enabled = data.is_alert_enabled, is_blocked = data.is_blocked, is_followed = data.is_followed, email = data.email, last_modified_at = data.last_modified_at, last_login_at = data.last_login_at, is_activated = data.is_activated, has_password = data.has_password, is_newsletter_subscriber = data.is_newsletter_subscriber, is_phone_verified = data.is_phone_verified, is_shown_in_discovery = data.is_shown_in_discovery, preferences = data.preferences, onboarding = data.onboarding, free_trial = data.free_trial, sns = data.sns, trading = data.trading, support = data.support, pro = data.pro, ban = data.ban, onesignal_hash = data.onesignal_hash;
    var follower_count = statistics.follower_count, following_count = statistics.following_count, reputation_count = statistics.reputation_count, idea_count = statistics.idea_count, like_count = statistics.like_count, view_count = statistics.view_count;
    var username = profile.username, fullname = profile.fullname, about = profile.about, website = profile.website, avatar = profile.avatar, country = profile.country, language = profile.language, gender = profile.gender, location = profile.location, address = profile.address, birthday = profile.birthday, phone = profile.phone, occupation = profile.occupation;
    var result = {
        id: String(id),
        username: username,
        fullname: fullname,
        email: email,
        activated: is_activated ? "1" : "0",
        banned: String(ban.code),
        user_banned_until: formatDate(ban.until),
        ban_reason: ban.reason === "" ? null : ban.reason,
        last_login: formatDate(last_login_at),
        created: formatDate(created_at),
        modified: formatDate(last_modified_at),
        avatar: avatar.default,
        about: about,
        location: location,
        website: website,
        occupation: occupation,
        gender: gender,
        birthday: birthday,
        phone: phone.formatted,
        address: address,
        hide_email: preferences.privacy.is_hide_email ? "1" : "0",
        // user_attr
        user_priv: String(privilege.code),
        // tutorial
        // user_newsletter
        country: country,
        exchange: exchange,
        facebook_id: sns.facebook_id,
        apple_id: sns.apple_id,
        google_id: sns.google_id,
        email_subscribe: is_newsletter_subscriber ? "1" : "0",
        user_phone_verification: is_phone_verified ? "1" : "0",
        facebook_hide: preferences.privacy.is_hide_facebook ? "1" : "0",
        language: language,
        user_preferences: {
            stream_version: preferences.stream.version
        },
        user_trading: String(trading.account_id),
        // user_badge_top
        additional: {
            reputations: reputation_count,
            followers: String(follower_count),
            ideas: String(idea_count),
            following: String(following_count),
            likes: like_count,
            views: view_count
        },
        followed: is_followed ? 1 : 0,
        ispro: trading.is_pro || pro.is_pro || !moment_default()().isAfter(free_trial.expired_at) ? 1 : 0,
        pro_active_since: formatDate(pro.active_since),
        pro_expire_at: formatDate(pro.expired_at),
        tradingpro: trading.is_pro ? 1 : 0,
        // official
        trending: badges.is_trending ? 1 : 0,
        ir_symbol: ir_symbols,
        isblocked: is_blocked ? 1 : 0,
        alert: is_alert_enabled ? 1 : 0,
        onboarding: onboarding.current_step,
        onboarding_done: onboarding.is_done ? 1 : 0,
        discover: is_shown_in_discovery ? 1 : 0,
        ftcode: free_trial.code,
        ftend: formatDate(free_trial.expired_at),
        realtrading_access: trading.has_realtrading_access ? 1 : 0,
        top_badge: badges.is_top ? 1 : 0,
        // is_term_agreed
        intercom: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, support.intercom), {
            email: support.intercom.email,
            created_at: support.intercom.created_at,
            phone: support.intercom.phone
        }),
        password: has_password ? 1 : 0,
        onesignal_hash: onesignal_hash,
        support: {
            id: support.id
        }
    };
    return result;
};

// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/lib/entities/profile.js







// api
// import { AWS_AVATAR_BUCKET } from 'constants/api';


// Utils


// model



// initial state
var initialState = {
    data: models_user.schema,
    isLoading: true,
    error: null,
    message: "",
    // for flagging btn back is clicked
    isClickedPreviousButton: false,
    connectSocialMedia: {
        data: {},
        isLoading: true,
        error: null,
        message: ""
    }
};
// Selectors -------------------------------------------------------------------
var selectors = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile;
}, function(state) {
    return {
        data: state.data,
        isLoading: state.isLoading,
        error: state.error,
        message: state.message,
        isClickedPreviousButton: state.isClickedPreviousButton,
        connectSocialMedia: state.connectSocialMedia
    };
});
var profileSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data;
}, function(data) {
    return data;
});
var proExpirySelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data;
}, function(data) {
    return data.pro_expire_at;
});
var userIdSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data.id;
}, function(id) {
    return id;
});
// Actions ---------------------------------------------------------------------
// types
var CONTEXT = "@redux/user";
var actionType = {
    FETCH_PROFILE: "".concat(CONTEXT, "/FETCH_PROFILE"),
    UPDATE_PROFILE: "".concat(CONTEXT, "/UPDATE_PROFILE"),
    CONNECT_SOCIAL_MEDIA: "".concat(CONTEXT, "/CONNECT_SOCIAL_MEDIA"),
    UPDATE_PREFERENCE: "".concat(CONTEXT, "/UPDATE_PREFERENCE")
};
// effects
var effects = {
    // getTrendinguser -------------------------------------------------------------------
    getUserProfile: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FETCH_PROFILE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(username) {
            var response, _data, data, message, _$error, userId, _$username, email, avatar, responseGetVerifiedBadge, mappedData, isEmitenUser;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return user/* default.getUserProfile */.Z.getUserProfile(username);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 18;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        userId = data.id ? Number(data.id) : 0;
                        _$username = data.profile && data.profile.username || "";
                        email = data.email || "";
                        avatar = data.profile && data.profile.avatar && data.profile.avatar.default || "";
                        _ctx.next = 12;
                        return verifiedBadge/* default.getVerifiedBadgeUser */.Z.getVerifiedBadgeUser(userId);
                    case 12:
                        responseGetVerifiedBadge = _ctx.sent;
                        if (!_$error) {
                            _ctx.next = 15;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 15:
                        mappedData = userResponseMapping(data);
                        // Clevertap pprofile initialization
                        if (responseGetVerifiedBadge && responseGetVerifiedBadge.data) {
                            isEmitenUser = responseGetVerifiedBadge.data && responseGetVerifiedBadge.data.is_emitten || false;
                            // Track if username is empty
                            if (!_$username) {
                                (0,logger/* default */.ZP)(new Error("[CT initialization Error]: username is empty"), {
                                    place: "src/lib/entities/profile.js",
                                    event: "getUserProfile",
                                    eventParam: {
                                        profile: data.profile
                                    }
                                });
                            }
                            (0,clevertap/* clevertapProfilingUser */.$b)({
                                isInitProfile: true,
                                identity: _$username,
                                email: email,
                                profilePictureUrl: avatar,
                                isEmitenUser: isEmitenUser
                            });
                        }
                        return _ctx.abrupt("return", {
                            data: mappedData,
                            message: message
                        });
                    case 18:
                        throw new Error("Attempt to fetch Trending user Failed");
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    21
                ]
            ]);
        }));
        return function(username) {
            return _ref.apply(this, arguments);
        };
    }()),
    // editUserProfile -------------------------------------------------------------------
    editUserProfile: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UPDATE_PROFILE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestBody) {
            var preventUpdate, body, response, _data, data, message, _$error, sanitizedData, mappedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        preventUpdate = requestBody.preventUpdate, body = (0,_object_without_properties/* default */.Z)(requestBody, [
                            "preventUpdate"
                        ]);
                        _ctx.next = 4;
                        return user/* default.editUserProfile */.Z.editUserProfile(body);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 12;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        sanitizedData = (0,_object_spread/* default */.Z)({}, data);
                        mappedData = userResponseMapping(data);
                        return _ctx.abrupt("return", {
                            data: mappedData,
                            message: message,
                            preventUpdate: preventUpdate
                        });
                    case 12:
                        throw new Error("Attempt to fetch Trending user Failed");
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // userConnectSocialMedia -------------------------------------------------------------------
    userConnectSocialMedia: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CONNECT_SOCIAL_MEDIA, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var socialMediaName, requestBody, dispatch, response, _data, data, message, _$error, userAccess, usernameAuth;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        socialMediaName = param.socialMediaName, requestBody = param.requestBody, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return user/* default.userConnectSocialMedia */.Z.userConnectSocialMedia(socialMediaName, requestBody);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 13;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        userAccess = auth/* default.getUserAccess */.Z.getUserAccess();
                        usernameAuth = userAccess.username;
                        dispatch(effects.getUserProfile(usernameAuth));
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        throw new Error("Attempt to connect social media Failed");
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    updatePreference: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UPDATE_PREFERENCE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestData) {
            var response, _data, data, error, error_type, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return user/* default.updatePreference */.Z.updatePreference(requestData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt update preference failed");
                    case 6:
                        _data = response.data, data = _data.data, error = _data.error, error_type = _data.error_type, message = _data.message;
                        if (!(error || error_type)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(message);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestData) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducer ---------------------------------------------------------------------
var reducers = {
    /**
   * updateOnboardingStep
   * Store back onboarding progress step
   * @param step - object of previous progress step
   * @param isClickedPreviousButton - boolean
   */ updateOnboardingStep: function(draft, action) {
        var step = action.payload.step;
        var newData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft.data), {
            onboarding: step
        });
        draft.data = newData;
    },
    /**
   * resetIsClickedPreviousButton
   * change isClickedPreviousButton to false
   */ resetIsClickedPreviousButton: function(draft) {
        draft.isClickedPreviousButton = false;
    },
    /**
   * reset profile state
   */ resetProfileState: function(draft) {
        draft.data = models_user.schema;
    }
};
var _obj;
// Extra Reducer ---------------------------------------------------------------
var extraReducers = (_obj = {}, // Get Userprofile -----------------------------------------------------------
(0,_define_property/* default */.Z)(_obj, effects.getUserProfile.pending, function(state) {
    state.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.getUserProfile.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.error = error;
    } else {
        state.data = data;
    }
    state.message = message;
    state.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.getUserProfile.rejected, function(state, action) {
    state.error = action.payload.error;
    state.isLoading = false;
}), // Post editUserProfile -----------------------------------------------------------
// replace state profile
(0,_define_property/* default */.Z)(_obj, effects.editUserProfile.pending, function(state) {
    state.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.editUserProfile.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, preventUpdate = _payload.preventUpdate;
    if (error) {
        state.error = error;
    } else {
        // to handle when user has clicked previous button
        // used last onboarding step from state
        // to be used in button next
        var isClickedPreviousButton = state.isClickedPreviousButton;
        var _data = state.data, lastProgress = _data.onboarding;
        var newDataWithLastProgress = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.data), {
            onboarding: lastProgress
        });
        if (!preventUpdate) {
            state.data = isClickedPreviousButton ? newDataWithLastProgress : data;
        }
    }
    state.message = message;
    state.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.editUserProfile.rejected, function(state, action) {
    state.error = action.payload.error;
    state.isLoading = false;
}), // Post userConnectSocialMedia -----------------------------------------------------------
(0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.pending, function(state) {
    state.connectSocialMedia.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.connectSocialMedia.error = error;
    } else {
        state.connectSocialMedia.data = data;
    }
    state.connectSocialMedia.message = message;
    state.connectSocialMedia.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.rejected, function(state, action) {
    state.connectSocialMedia.error = action.payload.error;
    state.connectSocialMedia.isLoading = false;
}), _obj);
// Slice -----------------------------------------------------------------------
var profileSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "profile",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var profile = (profileSlice);


/***/ }),

/***/ 14229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42699);
/* harmony import */ var constants_localstorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44252);
/* harmony import */ var features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51346);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42227);





function getToken() {
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return {
            accessToken: {
                token: null,
                expiry: null,
                isValid: null
            },
            refresh: {
                token: null,
                expiry: null,
                isValid: null
            }
        };
    }
    var ls = localStorage;
    // set cookies
    // format date from backend is still in seconds, while
    // JS' date is in miliseconds format, thus multiply the date by 1000
    var accessToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx]) : null;
    var accessTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0]), 10) : null;
    var refreshToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4]) : null;
    var refreshTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv]), 10) : null;
    // check expiry
    var currentTime = Date.now();
    var isAccessTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(accessTokenExp, currentTime);
    var isRefreshTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(refreshTokenExp, currentTime);
    return {
        accessToken: {
            token: accessToken,
            expiry: accessTokenExp,
            isValid: isAccessTokenValid
        },
        refresh: {
            token: refreshToken,
            expiry: refreshTokenExp,
            isValid: isRefreshTokenValid
        }
    };
}
function saveToken(param) {
    var accessToken = param.accessToken, accessTokenExp = param.accessTokenExp, refreshToken = param.refreshToken, refreshTokenExp = param.refreshTokenExp, accessUser = param.accessUser;
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return;
    }
    if (accessUser) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessTokenExp.toString());
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshTokenExp.toString());
}
function updateAccessUser(accessUser) {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
}
function destroyToken() {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv);
        localStorage.removeItem("stbx-active-indexwatchlist");
        localStorage.removeItem("stbx-active-watchlist");
        localStorage.removeItem("stbx-active-widget");
        localStorage.removeItem("stbx-active-stream-header");
        localStorage.removeItem("stbx-active-stream");
        localStorage.removeItem("trade-orderbook-show-confirmation");
        localStorage.removeItem("tradeIsLogin");
        localStorage.removeItem("tradingVersion");
        localStorage.removeItem("tradingAccountType");
        localStorage.removeItem("taps");
        localStorage.removeItem("tradingBroker");
        localStorage.removeItem("lastTradingAccountType");
        localStorage.removeItem("register_trading_useractive_sinarmas");
        localStorage.removeItem("register_trading_sinarmas");
        localStorage.removeItem("register_trading_useractive");
        localStorage.removeItem("tradingBrokerList");
        localStorage.removeItem("financials-panel-amount");
        localStorage.removeItem("financials-panel-currency");
        localStorage.removeItem("financials-panel-datatype");
        localStorage.removeItem("financials-panel-lang");
        localStorage.removeItem("financials-panel-ordertype");
        localStorage.removeItem("financials-panel-reportype");
        localStorage.removeItem("financials-panel-rounding-count");
        localStorage.removeItem("financials-panel-rounding-symbol");
        localStorage.removeItem("financials-panel-statetype");
        localStorage.removeItem("crisp");
        localStorage.removeItem("formula");
        localStorage.removeItem("stbx-active-trending-date");
        localStorage.removeItem("ws");
        features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__/* .localStorageOrderbookHandler.remove */ .Ku.remove();
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
}
/**
 * getUserAccess
 * to get user data from auth login
 * @param {*} ctx
 */ function getUserAccess() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && localStorage && localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns]) : {};
}
var setLocalCrispSettings = function(crisp) {
    localStorage.location = window.location.origin;
    localStorage.crisp = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(crisp);
};
var setLocalIntercomSettings = function(intercom) {
    localStorage.location = window.location.origin;
    localStorage.intercom = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(intercom);
};
var isLoggedIn = function() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && Boolean(localStorage === null || localStorage === void 0 ? void 0 : localStorage.at);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    isLoggedIn: isLoggedIn,
    getToken: getToken,
    saveToken: saveToken,
    destroyToken: destroyToken,
    getUserAccess: getUserAccess,
    updateAccessUser: updateAccessUser,
    setLocalCrispSettings: setLocalCrispSettings,
    setLocalIntercomSettings: setLocalIntercomSettings
});


/***/ }),

/***/ 48028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ clevertapProfilingUser; },
/* harmony export */   "Lq": function() { return /* binding */ clevertapEvent; },
/* harmony export */   "QU": function() { return /* binding */ clevertapInitProfileQueue; },
/* harmony export */   "Vg": function() { return /* binding */ clearClevertapState; },
/* harmony export */   "nh": function() { return /* binding */ academyUserProfiling; },
/* harmony export */   "ze": function() { return /* binding */ academyEventAnalytic; }
/* harmony export */ });
/* unused harmony export clevertapProfilingUserEligible */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91635);
/* eslint-disable no-underscore-dangle */ 


var clevertapProfileQueue = [];
function clevertapInitProfileQueue() {
    clevertapProfileQueue.forEach(function(instance) {
        return instance();
    });
    clevertapProfileQueue = [];
}
/**
 * this function will executes clevertap analytic based on isInitProfile
 * @param {boolean} isInitProfile
 * @param {string} username
 * @param {boolean} isVirtualTrading
 * @param {boolean} isTopUser
 * @param {boolean} isVerifiedUser
 * @param {boolean} isStockbitPro
 * @param {Date} registrationStartDate
 * @param {string} profilePictureUrl
 * @param {boolean} isSinarmasSecuritas
 * @param {string} email
 * @param {isStockbitSecuritas} isStockbitSecuritas
 * @return {void} no return after execute this function
 */ function clevertapProfilingUser(param) {
    var isInitProfile = param.isInitProfile, identity = param.identity, isVirtualTrading = param.isVirtualTrading, isTopUser = param.isTopUser, isVerifiedUser = param.isVerifiedUser, isStockbitPro = param.isStockbitPro, registrationStartDate = param.registrationStartDate, profilePictureUrl = param.profilePictureUrl, isSinarmasSecuritas = param.isSinarmasSecuritas, email = param.email, isStockbitSecuritas = param.isStockbitSecuritas, _isEmitenUser = param.isEmitenUser, isEmitenUser = _isEmitenUser === void 0 ? false : _isEmitenUser;
    // Track if username is empty
    if (!identity) {
        (0,_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(new Error("[CT initialization Error]: username is empty"), {
            place: "src/utils/clevertap.ts",
            event: "clevertapProfilingUser",
            eventParam: {
                profile: {
                    identity: identity,
                    email: email
                }
            }
        });
    }
    var clevertapProfilingData = {
        Name: identity,
        Identity: identity,
        "Is Virtual Trading": isVirtualTrading !== undefined ? isVirtualTrading : undefined,
        "Is Top User": isTopUser !== undefined ? isTopUser : undefined,
        "Is Verified User": isVerifiedUser !== undefined ? isVerifiedUser : undefined,
        "Is Stockbit Pro": isStockbitPro !== undefined ? isStockbitPro : undefined,
        "Registration Start Date": registrationStartDate !== undefined ? registrationStartDate : undefined,
        Photo: profilePictureUrl !== undefined ? "".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .AWS_AVATAR_BUCKET */ .cU, "/").concat(profilePictureUrl) : undefined,
        "Is Sinarmas Sekuritas": isSinarmasSecuritas !== undefined ? isSinarmasSecuritas : undefined,
        Email: email !== undefined ? email : undefined,
        "Is Stockbit Sekuritas": isStockbitSecuritas !== undefined ? isStockbitSecuritas : undefined,
        "Is Emiten User": isEmitenUser !== undefined ? isEmitenUser : undefined
    };
    // filter to remove undefined value of object
    var payload = Object.keys(clevertapProfilingData).reduce(function(acc, key) {
        var _acc = acc;
        if (clevertapProfilingData[key] !== undefined) {
            _acc[key] = clevertapProfilingData[key];
        }
        return _acc;
    }, {});
    var handleInitProfile = function() {
        var ref;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.onUserLogin.push({
            Site: payload
        });
    };
    var handleProfilePush = function() {
        var ref;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.profile.push({
            Site: payload
        });
    };
    var initProfileFunction = isInitProfile ? handleInitProfile : handleProfilePush;
    if (!window.clevertap) {
        clevertapProfileQueue.push(initProfileFunction);
        return;
    }
    initProfileFunction();
}
function clevertapEvent(eventName) {
    var eventObject = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Object.keys(eventObject).length > 0) {
        var // execute this impression if impression has additional attributes
        ref, ref1;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.push(eventName, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventObject));
    } else {
        var ref2, ref3;
        (ref2 = window.clevertap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.event) === null || ref3 === void 0 ? void 0 : ref3.push(eventName);
    }
}
function clevertapProfilingUserEligible(param) {
    var followers = param.followers, following = param.following, posts = param.posts, isMuted = param.isMuted, isVerifiedEligible = param.isVerifiedEligible;
    var clevertapProfilingDataEligible = {
        Followers: followers !== undefined ? followers : undefined,
        Following: following !== undefined ? following : undefined,
        Posts: posts !== undefined ? posts : undefined,
        "is Muted": isMuted !== undefined ? isMuted : undefined,
        "Is Verified Badge Eligible": isVerifiedEligible !== undefined ? isVerifiedEligible : undefined
    };
    // filter to remove undefined value of object
    var payload = Object.keys(clevertapProfilingDataEligible).reduce(function(acc, key) {
        var _acc = acc;
        if (clevertapProfilingDataEligible[key] !== undefined) {
            _acc[key] = clevertapProfilingDataEligible[key];
        }
        return _acc;
    }, {});
    window.clevertap.profile.push({
        Site: payload
    });
}
function academyEventAnalytic(eventName, parameter) {
    if (!eventName) {
        return;
    }
    clevertapEvent(eventName, parameter);
}
function academyUserProfiling() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
    var ref;
    if (!data && !data.parameter) {
        return;
    }
    // filter to remove undefined value of object
    // eslint-disable-next-line array-callback-return
    var payload = Object.keys(data.parameter).reduce(function(acc, key) {
        var currentAcc = acc;
        if (data[key] !== undefined) {
            currentAcc[key] = data[key];
            return currentAcc;
        }
        return null;
    }, {});
    (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.profile.push({
        Site: payload
    });
}
function clearClevertapState() {
    var ref, ref1;
    (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.logout();
    (ref1 = window.clevertap) === null || ref1 === void 0 ? void 0 : ref1.clear();
}


/***/ }),

/***/ 42227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ isMobileVersion; },
/* harmony export */   "C9": function() { return /* binding */ getLastSlashURL; },
/* harmony export */   "Ex": function() { return /* binding */ saveObject; },
/* harmony export */   "FD": function() { return /* binding */ emptyObject; },
/* harmony export */   "GD": function() { return /* binding */ convertToEventValue; },
/* harmony export */   "Gf": function() { return /* binding */ sanitizeHTMLTags; },
/* harmony export */   "OB": function() { return /* binding */ decodeBase64ToJS; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "TE": function() { return /* binding */ copyTextToClipboard; },
/* harmony export */   "Tk": function() { return /* binding */ handleErrorAvatar; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "hB": function() { return /* binding */ popupWindowToCenter; },
/* harmony export */   "hr": function() { return /* binding */ escapeRegExp; },
/* harmony export */   "k6": function() { return /* binding */ convertToSlug; },
/* harmony export */   "ko": function() { return /* binding */ replaceAll; },
/* harmony export */   "lz": function() { return /* binding */ sanitizeURL; },
/* harmony export */   "me": function() { return /* binding */ encodeBase64FromJS; },
/* harmony export */   "pV": function() { return /* binding */ getColorBasedOnNumber; },
/* harmony export */   "r$": function() { return /* binding */ capitalizer; },
/* harmony export */   "rK": function() { return /* binding */ transformAvatarUrl; }
/* harmony export */ });
/* unused harmony exports sortAlpha, setCharAt, newlineToBr, getPathFromUrl, trimText */
/* harmony import */ var js_base64__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52300);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25516);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* eslint-disable no-restricted-syntax */ /* eslint-disable indent */ /* eslint-disable no-param-reassign */ /* eslint-disable no-useless-escape */ /* eslint-disable no-restricted-globals */ /* eslint-disable no-nested-ternary */ /* eslint-disable wrap-iife */ 




/* eslint-disable import/prefer-default-export */ var copyTextToClipboard = function(text) {
    var customAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var input = document.createElement("input");
    input.setAttribute("type", "text");
    var body = document.querySelector("body");
    input.value = text;
    body.appendChild(input);
    input.select();
    document.execCommand("copy");
    body.removeChild(input);
    if (customAlert) {
        customAlert();
    } else {
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Link copied", constants_successMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
    }
};
function isMobileVersion() {
    var check = false;
    // eslint-disable-next-line func-names
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function popupWindowToCenter(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    var newWindow = window.open(url, title, "scrollbars=yes, width=".concat(w, ", height=").concat(h, ", top=").concat(top, ", left=").concat(left));
    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}
function getLastSlashURL(url) {
    return url.substr(url.lastIndexOf("/") + 1);
}
function handleErrorAvatar(e, paramUsername) {
    var fallbackUrl = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .SITE_URL */ ._O, "/images/avatar.png");
    e.target.onerror = null;
    e.target.src = fallbackUrl;
}
function parsePureValueSep(pv) {
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i -= 1){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i += 1;
            }
            // Add the letter for the abbreviation
            number += " ".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            result = parsePureValueSep(raw[0]);
            result = raw[1] && raw[1] !== "K" ? "".concat(result, " ").concat(raw[1]) : result;
            if (raw[1] === "K") {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result);
            }
        } else {
            result = number;
        }
    }
    return result;
};
function sortAlpha(a, b) {
    var ax = a.toLowerCase();
    var bx = b.toLowerCase();
    return ax < bx ? -1 : ax > bx ? 1 : 0;
}
/**
 * Convert data to event change data to be used in `useForm` hooks
 * @param {*} val
 * @returns {Object}
 */ var convertToEventValue = function(val) {
    var data = {
        target: {
            value: val
        }
    };
    return data;
};
/**
 * Convert text to slug
 * @param {string} text
 * @return {string}
 */ function convertToSlug(text) {
    if (!text) return text;
    return text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-$/, ""); // Trim - from end of text
}
/**
 * Capitalize
 * @param {string} string
 * @return {string}
 */ function capitalizeFirstLetter(string) {
    if (!string) return string;
    var newString = string.toLowerCase();
    return newString.charAt(0).toUpperCase() + newString.slice(1);
}
function setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
}
/**
 * Capitalizer
 * @param {string} string
 * @param {number} at
 * @return {string}
 */ function capitalizer(string) {
    var at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!string) return string;
    var upperCasedLetter = string.charAt(at).toUpperCase();
    return setCharAt(string, at, upperCasedLetter);
}
// helpers
var encodeBase64FromJS = function(object) {
    var result = object;
    if (typeof object === "object") {
        result = JSON.stringify(object);
    }
    return js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.encode */ .DS.encode(result);
};
var decodeBase64ToJS = function(base64) {
    var decoded = js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.decode */ .DS.decode(base64);
    var result = decoded;
    try {
        result = JSON.parse(decoded);
    } catch (e) {
        result = decoded;
    }
    return result;
};
// local storage utils
var saveObject = function(key, object) {
    window.localStorage.setItem("location", window.location.origin);
    window.localStorage.setItem(key, encodeBase64FromJS(object));
};
/**
 * Turn newline into <br/>
 * @param {string} str
 * @param {string=} isXhtml
 * @returns {string}
 */ function newlineToBr(str, isXhtml) {
    var breakTag = isXhtml || typeof isXhtml === "undefined" ? "<br />" : "<br>";
    return "".concat(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1".concat(breakTag, "$2"));
}
function emptyObject(obj) {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
/**
 * @deprecated - do not use for user input manipulation
 * @param {} str
 * @param {*} match
 * @param {*} replacement
 * @returns str
 */ function replaceAll(str, match, replacement) {
    return str.replace(new RegExp(escapeRegExp(match), "g"), function() {
        return replacement;
    });
}
var getColorBasedOnNumber = function(number) {
    if (Number(number) > 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary;
    if (Number(number) < 0) return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].sunsetOrange */ .Z.sunsetOrange;
    return _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highempahis */ .Z.highempahis;
};
function getPathFromUrl(url) {
    return url.split("?")[0];
}
function trimText(description, maxLength) {
    var trimmedString = description.substr(0, maxLength);
    var lastStringIndex = Math.min(trimmedString.length, trimmedString.lastIndexOf(" "));
    trimmedString = trimmedString.substr(0, lastStringIndex);
    if (description.length > maxLength) {
        trimmedString += "...";
    }
    return trimmedString;
}
var transformAvatarUrl = function() {
    var avatarUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (avatarUrl.startsWith("http")) {
        return avatarUrl;
    }
    return "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .AVATAR_URL */ .q$, "/").concat(avatarUrl);
};
/**
 * sanitizeHTMLTags
 * Remove Curve Brackets from string
 * to prevent xss, security issues
 *
 * This function is created because regex "/(<([^>]+)>)/gi" that already
 * used in v2 is not accepted in sonar-scan v3.
 * This function already have unit test
 * to makesure the result same as the previous regex implementation.
 * @param {String} originalString
 * @returns
 */ var sanitizeHTMLTags = function() {
    var originalString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var result = "";
    var start = 0;
    while(true){
        var startBracket = originalString.indexOf("<", start);
        if (startBracket === -1) break;
        var endBracket = originalString.indexOf(">", startBracket);
        if (endBracket === -1) break;
        if (endBracket - startBracket === 1) {
            result += originalString.substring(startBracket - (startBracket - start), endBracket + 1);
        } else {
            result += originalString.substring(start, startBracket);
        }
        start = endBracket + 1;
    }
    result += originalString.substring(start);
    return result;
};
function sanitizeURL() {
    var urlToCheck = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/";
    if (urlToCheck[0] === "/") {
        return urlToCheck;
    }
    try {
        var safeProtocol = [
            "https",
            "http"
        ];
        var safeHost = [
            "stockbit.com",
            "ui.lab.stockbit.com",
            "itunes.apple.com",
            "play.google.com", 
        ];
        var url = new URL(urlToCheck);
        if (safeProtocol.indexOf(url === null || url === void 0 ? void 0 : url.protocol) < 0) {
            throw Error("Not safe protocol: ".concat(url === null || url === void 0 ? void 0 : url.protocol));
        }
        if (safeHost.indexOf(url === null || url === void 0 ? void 0 : url.host) < 0) {
            throw Error("Not safe host: ".concat(url === null || url === void 0 ? void 0 : url.host));
        }
        return urlToCheck;
    } catch (err) {
        ;
        return constants_api__WEBPACK_IMPORTED_MODULE_1__/* .SITE_URL */ ._O;
    }
}



/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ setUserId; },
/* harmony export */   "Kp": function() { return /* binding */ sentrySetUser; },
/* harmony export */   "gB": function() { return /* binding */ sentryLog; }
/* harmony export */ });
/* unused harmony export noticeError */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14229);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42227);







var setUserId = function(userId) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger || !(logger === null || logger === void 0 ? void 0 : logger.setUserId)) return;
    if (userId !== null) logger === null || logger === void 0 ? void 0 : logger.setUserId(userId.toString());
};
var noticeError = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
err, customAttr) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger) return;
    // Get User Id from localStorage
    var ref = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess() || {}, userId = ref.id;
    // Set New Relic User Id
    if (err) {
        setUserId(userId || null);
        var mappedCustomAttr;
        try {
            mappedCustomAttr = Object.keys(customAttr).reduce(function(a, key) {
                var newKey = key.startsWith("sb") ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 2) : "sb".concat((0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 0));
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, a), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newKey, customAttr[key]));
            }, {});
        } catch (error) {
            mappedCustomAttr = customAttr;
        }
        logger.noticeError(err, mappedCustomAttr);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (noticeError);
var sentryLog = function(options) {
    var error = options.error, scopeName = options.scope, level = options.level, username = options.username, httpStatusCode = options.httpStatusCode, tags = options.tags;
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .withScope */ .$e(function(scope) {
        scope.setTag("scope", scopeName);
        scope.setLevel(level);
        if (httpStatusCode) {
            scope.setTag("http-status-code", httpStatusCode);
        }
        if (Array.isArray(tags) && tags.length > 0) {
            tags.forEach(function(item) {
                scope.setTag(item.title, item.value);
            });
        }
        if (username) {
            scope.setUser({
                username: username
            });
        }
        if (typeof error === "string") {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureMessage */ .uT(error);
        }
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, Error)) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb(error);
        }
    });
};
var sentrySetUser = function(isLoggedIn) {
    if (!isLoggedIn) {
        return;
    }
    var userData = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess();
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .setUser */ .av({
        username: userData === null || userData === void 0 ? void 0 : userData.username,
        id: userData === null || userData === void 0 ? void 0 : userData.id
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,75819,46819,88069,7648,25935,51225,40142,50299,92961,33070,58928,76750,79931,70735,35851,67555,76219,71584,92432,49774,92888,40179], function() { return __webpack_exec__(81424); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);